/** UI strings: key = Bahasa Melayu text. Generated from the key list (scripts/i18n-keys.mjs). */
export const TA: Record<string, string> = {
  "(pilih 1)": "(1 தேர்வு)",
  "(sehingga {date})": "({date} வரை)",
  "1 kredit = 1 kertas soalan yang dijana. Kertas yang gagal dijana, JomBelajar dan muat turun semula PDF tidak ditolak.": "1 கடன்புள்ளி = உருவாக்கப்பட்ட 1 கேள்வித் தாள். தோல்வியடைந்த உருவாக்கம், JomBelajar, PDF மீண்டும் பதிவிறக்கம் கழிக்கப்படாது.",
  "10 soalan daripada unit ini. Jawapan terus disemak.": "இந்த அலகிலிருந்து 10 கேள்விகள். பதில்கள் உடனே சரிபார்க்கப்படும்.",
  "100 pembeli pertama": "முதல் 100 வாங்குநர்கள்",
  "60 saat. Berapa banyak yang anda boleh?": "60 வினாடிகள். எத்தனை சரியாகச் சொல்வீர்கள்?",
  "AI sedang menulis dan menyemak soalan. Ini boleh ambil sehingga 1–2 minit.": "AI கேள்விகளை எழுதிச் சரிபார்க்கிறது. இதற்கு 1–2 நிமிடங்கள் ஆகலாம்.",
  "AI sedang menulis set penuh dan menyemaknya. Ini boleh ambil 2–5 minit.": "AI முழுத் தொகுப்பையும் எழுதிச் சரிபார்க்கிறது. இதற்கு 2–5 நிமிடங்கள் ஆகலாம்.",
  "AI tidak lulus semakan automatik. Cuba lagi atau kurangkan SP.": "AI வெளியீடு தானியங்கி சோதனையில் தேறவில்லை. மீண்டும் முயலவும் அல்லது குறைவான கற்றல் தரநிலைகளைத் தேர்ந்தெடுக்கவும்.",
  "AI tidak lulus semakan automatik. Cuba lagi atau kurangkan topik.": "AI வெளியீடு தானியங்கி சோதனையில் தேறவில்லை. மீண்டும் முயலவும் அல்லது குறைவான தலைப்புகளைத் தேர்ந்தெடுக்கவும்.",
  "Adakah jawapan ini betul? Jawab sebanyak mungkin dalam 60 saat!": "இந்தப் பதில் சரியா? 60 வினாடிகளில் முடிந்தவரை பதிலளியுங்கள்!",
  "Affiliate": "இணைப்பாளர்",
  "Akan datang": "விரைவில்",
  "Log keluar": "வெளியேறு",
  "Akaun": "கணக்கு",
  "Akaun bank disimpan.": "வங்கிக் கணக்கு சேமிக்கப்பட்டது.",
  "Akaun bank untuk bayaran": "பணம் பெறும் வங்கிக் கணக்கு",
  "Akaun ini sudah mempunyai lesen.": "இந்தக் கணக்கிற்கு ஏற்கனவே உரிமம் உள்ளது.",
  "Akses semua modul": "அனைத்து தொகுதிகளுக்கும் அணுகல்",
  "Aktifkan lesen": "உரிமத்தைச் செயல்படுத்து",
  "Aktifkan lesen saya": "என் உரிமத்தைச் செயல்படுத்து",
  "Anda dapat RM10 setiap kali": "ஒவ்வொரு முறையும் நீங்கள் RM10 பெறுவீர்கள்",
  "Anda dapat {a} (pembeli RM69) / {b} (pembeli RM79)": "நீங்கள் {a} (RM69 வாங்குநர்) / {b} (RM79 வாங்குநர்) பெறுவீர்கள்",
  "Anda layak jadi affiliate": "நீங்கள் இணைப்பாளராகத் தகுதியானவர்",
  "Anda sudah ada permintaan bayaran yang belum selesai.": "நிலுவையில் உள்ள பணம் எடுக்கும் கோரிக்கை ஏற்கனவே உள்ளது.",
  "Anda tiada akses.": "உங்களுக்கு அணுகல் இல்லை.",
  "BM & BI: Kertas 1 Pemahaman + Kertas 2 Penulisan": "மலாய் & ஆங்கிலம்: தாள் 1 புரிதல் + தாள் 2 எழுத்து",
  "Baca jarum jam dan pilih waktu yang betul.": "கடிகார முட்களைப் படித்து சரியான நேரத்தைத் தேர்ந்தெடுங்கள்.",
  "Baca jarum jam dan pilih waktunya.": "கடிகாரத்தைப் படித்து நேரத்தைத் தேர்ந்தெடுங்கள்.",
  "Susunan bahagian mengikut subjek · aras rendah:sederhana:tinggi = 5:3:2": "பகுதிகள் பாடத்தின் வடிவமைப்பின்படி அமையும் · எளிது:நடுத்தரம்:கடினம் = 5:3:2",
  "Bahasa Arab": "அரபு மொழி",
  "Bahasa Cina": "சீன மொழி",
  "Bahasa Inggeris": "ஆங்கிலம்",
  "Bahasa Melayu": "மலாய் மொழி",
  "Bahasa Tamil": "தமிழ்",
  "Bahasa kertas": "தாளின் மொழி",
  "Baki belum cukup minimum pengeluaran.": "உங்கள் இருப்பு குறைந்தபட்ச பணம் எடுக்கும் தொகையை விடக் குறைவு.",
  "Baki boleh dikeluarkan": "எடுக்கக்கூடிய இருப்பு",
  "Baki boleh dikeluarkan {amount}. Minimum pengeluaran {min}.": "எடுக்கக்கூடிய இருப்பு {amount}. குறைந்தபட்சம் {min}.",
  "Baki kertas AI": "மீதமுள்ள AI தாள்கள்",
  "Bank / e-wallet": "வங்கி / மின்-பணப்பை",
  "Batal": "ரத்து",
  "Bayar": "செலுத்து",
  "Bayar harga barang dengan tepat. Tekan syiling dan wang kertas, kemudian tekan Bayar.": "சரியான விலையைச் செலுத்துங்கள். நாணயங்களையும் நோட்டுகளையும் தட்டி, பின் செலுத்து என்பதைத் தட்டுங்கள்.",
  "Bayar harga dengan syiling dan wang kertas.": "நாணயங்கள், நோட்டுகளால் விலையைச் செலுத்துங்கள்.",
  "Bayar kepada {name} jumlah tepat:": "{name} க்கு இந்தச் சரியான தொகையைச் செலுத்தவும்:",
  "Bayar melalui DuitNow QR.": "DuitNow QR மூலம் செலுத்தவும்.",
  "Bayar sekali, guna selamanya": "ஒருமுறை செலுத்துங்கள், என்றென்றும் பயன்படுத்துங்கள்",
  "Bayaran": "கொடுப்பனவு",
  "Bayaran belum disahkan.": "கட்டணம் இன்னும் உறுதிப்படுத்தப்படவில்லை.",
  "Bayaran disahkan": "கட்டணம் உறுதிப்படுத்தப்பட்டது",
  "Bayaran diterima untuk semakan. Kredit akan ditambah selepas disahkan.": "கட்டணம் சரிபார்ப்புக்குப் பெறப்பட்டது. உறுதிப்படுத்தியதும் கடன்புள்ளிகள் சேர்க்கப்படும்.",
  "Pembayaran dalam talian tidak tersedia buat masa ini. Sila cuba lagi sebentar nanti.": "ஆன்லைன் கட்டணம் தற்போது கிடைக்கவில்லை. சிறிது நேரம் கழித்து மீண்டும் முயற்சிக்கவும்.",
  "Bayaran tidak dapat disahkan": "கட்டணத்தை உறுதிப்படுத்த முடியவில்லை",
  "Belajar Lebih Bijak Bersama JomCerdik": "JomCerdik உடன் புத்திசாலித்தனமாகக் கற்போம்",
  "Belajar sambil bermain. Setiap permainan dikira dalam kemajuan anda.": "விளையாடிக்கொண்டே கற்போம். ஒவ்வொரு விளையாட்டும் உங்கள் முன்னேற்றத்தில் சேரும்.",
  "Beli JomCerdik Lifetime": "JomCerdik வாழ்நாள் உரிமம் வாங்கவும்",
  "Beli sekarang": "இப்போதே வாங்கவும்",
  "Belum ada jualan. Kongsi link anda di WhatsApp, Telegram atau Facebook.": "இன்னும் விற்பனை இல்லை. உங்கள் இணைப்பை WhatsApp, Telegram அல்லது Facebook இல் பகிருங்கள்.",
  "Belum ada kertas.": "இன்னும் தாள்கள் இல்லை.",
  "Berapa bahagian pizza yang ada pepperoni? Pilih pecahan yang betul.": "பீட்சாவின் எவ்வளவு பகுதியில் பெப்பரோனி உள்ளது? சரியான பின்னத்தைத் தேர்ந்தெடுங்கள்.",
  "Berapa pecahan berlorek? (bentuk termudah)": "நிழலிட்ட பின்னம் எது? (எளிய வடிவம்)",
  "Berapa pecahan pizza yang berlorek merah?": "பீட்சாவின் எந்தப் பின்னம் சிவப்பாக உள்ளது?",
  "Betul": "சரி",
  "Betul atau Salah Kilat": "சரியா தவறா மின்னல்",
  "Betul!": "சரி!",
  "Betul! Laju!": "சரி! வேகம்!",
  "Bilangan soalan: {n}": "கேள்விகளின் எண்ணிக்கை: {n}",
  "Buat pesanan baharu": "புதிய ஆர்டர் செய்யவும்",
  "Ciri ini untuk pemegang lesen.": "இந்த அம்சம் உரிமம் உள்ளவர்களுக்கு மட்டும்.",
  "Contoh": "உதாரணம்",
  "Cuba lagi": "மீண்டும் முயலவும்",
  "Cuba lagi. Anda pasti boleh!": "மீண்டும் முயலுங்கள். உங்களால் முடியும்!",
  "Cuba lagi. Baca semula nota dan jawab sekali lagi.": "மீண்டும் முயலவும். குறிப்புகளை மறுபடி படித்து மீண்டும் பதிலளிக்கவும்.",
  "DSKP ({n} soalan)": "DSKP ({n} கேள்விகள்)",
  "Dapatkan lesen": "உரிமம் பெறவும்",
  "Dapatkan link affiliate saya": "என் இணைப்பாளர் இணைப்பைப் பெறு",
  "Dasar Privasi": "தனியுரிமைக் கொள்கை",
  "Data DSKP sedang dimuatkan ke sistem. Cuba lagi sebentar lagi.": "DSKP தரவு ஏற்றப்படுகிறது. சிறிது நேரத்தில் மீண்டும் முயலவும்.",
  "Dibatalkan (refund)": "ரத்து செய்யப்பட்டது (பணம் திருப்பம்)",
  "Dibayar": "செலுத்தப்பட்டது",
  "Diluluskan": "அங்கீகரிக்கப்பட்டது",
  "Diminta": "கோரப்பட்டது",
  "Disalin ✓": "நகலெடுக்கப்பட்டது ✓",
  "Ditolak": "நிராகரிக்கப்பட்டது",
  "Dokumen undang-undang ini dalam Bahasa Melayu. Versi Bahasa Melayu ialah rujukan rasmi.": "இந்தச் சட்ட ஆவணம் மலாய் மொழியில் உள்ளது. மலாய் பதிப்பே அதிகாரப்பூர்வ குறிப்பு.",
  "Duit anda": "உங்கள் பணம்",
  "Early Bird (100 terawal)": "முன்பதிவு விலை (முதல் 100)",
  "Early Bird 2 (pembeli 101–200)": "முன்பதிவு விலை 2 (101–200 வாங்குநர்கள்)",
  "Emel": "மின்னஞ்சல்",
  "Emel tidak sah.": "தவறான மின்னஞ்சல்.",
  "Faham! Seterusnya →": "புரிந்தது! அடுத்து →",
  "Faham! ✔": "புரிந்தது! ✔",
  "Fail terlalu besar. Maksimum 5 MB.": "கோப்பு மிகப் பெரியது. அதிகபட்சம் 5 MB.",
  "Format UASA": "UASA வடிவம்",
  "Format UASA (lama)": "UASA வடிவம் (பழையது)",
  "Format kertas tidak dijumpai.": "தாள் வடிவம் கிடைக்கவில்லை.",
  "Fungsi ini sedang dibina (Fasa {phase}). Tiada data dipaparkan sehingga ia disambungkan ke sistem sebenar.": "இந்த அம்சம் உருவாக்கப்படுகிறது (கட்டம் {phase}). நேரடி அமைப்புடன் இணைக்கும் வரை தரவு காட்டப்படாது.",
  "Gambar atau PDF (maksimum 5 MB). Invois diemel selepas bayaran disahkan.": "படம் அல்லது PDF (அதிகபட்சம் 5 MB). கட்டணம் உறுதியானதும் விலைப்பட்டியல் மின்னஞ்சலில் அனுப்பப்படும்.",
  "Gambar atau PDF resit DuitNow / bank (maksimum 5 MB). Invois rasmi akan diemel selepas bayaran disahkan.": "DuitNow / வங்கி ரசீதின் படம் அல்லது PDF (அதிகபட்சம் 5 MB). கட்டணம் உறுதியானதும் அதிகாரப்பூர்வ விலைப்பட்டியல் மின்னஞ்சலில் அனுப்பப்படும்.",
  "Geografi": "புவியியல்",
  "Habis": "விற்றுத் தீர்ந்தது",
  "Had penjanaan dicapai. Kertas lama masih boleh dimuat turun.": "உருவாக்க வரம்பு எட்டப்பட்டது. பழைய தாள்களைப் பதிவிறக்கலாம்.",
  "Halaman tidak dijumpai": "பக்கம் கிடைக்கவில்லை",
  "Hampir habis!": "கிட்டத்தட்ட தீர்ந்துவிட்டது!",
  "Hantar": "சமர்ப்பி",
  "Hantar pautan": "இணைப்பை அனுப்பு",
  "Harga": "விலை",
  "Harga awal untuk pembeli terawal": "முதல் வாங்குநர்களுக்கான தொடக்க விலை",
  "Harga biasa": "வழக்கமான விலை",
  "Harga biasa selepas itu": "அதன் பிறகு வழக்கமான விலை",
  "Harga {p1} dan {p2} hanya untuk pembelian terus di sini. Hanya 200 pembeli awal boleh menjadi affiliate: rakan anda beli pada {p3}, dan anda dapat {c1} (jika anda beli {p1}) atau {c2} (jika anda beli {p2}) bagi setiap jualan.": "{p1} மற்றும் {p2} விலைகள் இங்கு நேரடியாக வாங்குவதற்கு மட்டுமே. முதல் 200 வாங்குநர்கள் மட்டுமே இணைப்பாளராகலாம்: உங்கள் நண்பர்கள் {p3} க்கு வாங்குவார்கள்; ஒவ்வொரு விற்பனைக்கும் நீங்கள் {c1} ({p1} க்கு வாங்கியிருந்தால்) அல்லது {c2} ({p2} க்கு வாங்கியிருந்தால்) பெறுவீர்கள்.",
  "Harga {price} + {sen} sen kod padanan.": "விலை {price} + {sen} சென் பொருத்தக் குறியீடு.",
  "Hebat! Teruskan usaha.": "அருமை! தொடர்ந்து முயலுங்கள்.",
  "Ikut DSKP": "DSKP படி",
  "Imbas & bayar": "ஸ்கேன் செய்து செலுத்தவும்",
  "Itu sebenarnya betul!": "அது உண்மையில் சரியானது!",
  "Jam Ajaib": "மாயக் கடிகாரம்",
  "Jam analog": "அனலாக் கடிகாரம்",
  "Jana kertas": "தாளை உருவாக்கு",
  "Jana set soalan": "கேள்வித் தொகுப்பை உருவாக்கு",
  "Jawab betul untuk melompat ke batu seterusnya. Sampai ke istana sebelum nyawa habis!": "சரியாகப் பதிலளித்து அடுத்த கல்லுக்குத் தாவுங்கள். உயிர்கள் தீரும் முன் கோட்டையை அடையுங்கள்!",
  "Jawab betul untuk sampai ke istana.": "சரியாகப் பதிலளித்து கோட்டையை அடையுங்கள்.",
  "Jawapan betul: {x}": "சரியான பதில்: {x}",
  "Jawapan: ": "பதில்: ",
  "Jenis": "வகை",
  "Jom belajar hari ini!": "இன்று கற்போம்!",
  "Jom guna JomCerdik — nota, kuiz dan kertas latihan ikut DSKP untuk anak-anak. Daftar di sini: {link}": "JomCerdik பயன்படுத்துங்கள் — குழந்தைகளுக்கான DSKP அடிப்படையிலான குறிப்புகள், வினாடி வினாக்கள், பயிற்சித் தாள்கள். இங்கே பதிவு செய்யுங்கள்: {link}",
  "JomBelajar untuk pemegang lesen JomCerdik.": "JomBelajar JomCerdik உரிமம் உள்ளவர்களுக்கானது.",
  "Jualan lesen": "உரிம விற்பனை",
  "Jumlah": "தொகை",
  "Jumlah perlu dibayar (tepat)": "செலுத்த வேண்டிய தொகை (சரியாக)",
  "KBAT": "உயர்நிலை சிந்தனை",
  "Kad tertutup": "மூடிய அட்டை",
  "Kami akan hantar pautan log masuk ke emel anda. Tiada kata laluan.": "உள்நுழைவு இணைப்பை உங்கள் மின்னஞ்சலுக்கு அனுப்புவோம். கடவுச்சொல் தேவையில்லை.",
  "Kami tidak menjumpai bayaran yang sepadan. Hubungi kami dengan kod rujukan dan bukti bayaran.": "பொருந்தும் கட்டணம் கிடைக்கவில்லை. குறிப்புக் குறியீடு மற்றும் கட்டணச் சான்றுடன் எங்களைத் தொடர்பு கொள்ளுங்கள்.",
  "Kandungan sedang disediakan": "உள்ளடக்கம் தயாராகிறது",
  "Ke laman utama": "முகப்புக்குச் செல்",
  "Ke nota": "குறிப்புகளுக்கு",
  "Kedai Wang": "பணக் கடை",
  "Keluarkan duit": "பணம் எடு",
  "Keluarkan {amount}": "{amount} எடு",
  "Keluarkan {amount} ke {bank} {acc} ({holder})?": "{amount} ஐ {bank} {acc} ({holder}) க்கு எடுக்கவா?",
  "Kembali": "பின்செல்",
  "Kembali ke laman utama": "முகப்புக்குத் திரும்பு",
  "Kertas": "தாள்",
  "Kertas 1": "தாள் 1",
  "Kertas 1 - Pemahaman": "தாள் 1 - புரிதல்",
  "Kertas 2 - Penulisan": "தாள் 2 - எழுத்து",
  "Kertas AI": "AI தாள்கள்",
  "Kertas AI anda sudah habis.": "உங்கள் AI தாள்கள் தீர்ந்துவிட்டன.",
  "Kertas dan skema jawapan": "தாள்களும் விடைக் குறிப்புகளும்",
  "Kertas saya": "என் தாள்கள்",
  "Kertas siap! Muat turun di senarai 'Kertas saya'.": "தாள் தயார்! 'என் தாள்கள்' பட்டியலில் பதிவிறக்குங்கள்.",
  "Kertas soalan": "கேள்வித் தாள்",
  "Kertas {n}": "தாள் {n}",
  "Kod": "குறியீடு",
  "Kod dan huraian SP diambil terus daripada dokumen rasmi DSKP.": "கற்றல் தரநிலைக் குறியீடுகளும் விளக்கங்களும் அதிகாரப்பூர்வ DSKP ஆவணங்களிலிருந்து நேரடியாக எடுக்கப்பட்டவை.",
  "Kod referral: {code}": "பரிந்துரைக் குறியீடு: {code}",
  "Komisen anda: {amount} setiap jualan lesen + RM10 setiap topup pelanggan.": "உங்கள் தரகு: ஒவ்வொரு உரிம விற்பனைக்கும் {amount} + ஒவ்வொரு வாடிக்கையாளர் நிரப்புதலுக்கும் RM10.",
  "Komisen terkini": "சமீபத்திய தரகுகள்",
  "Kongsi di WhatsApp": "WhatsApp இல் பகிர்",
  "Kongsi link anda. Dapat komisen setiap jualan lesen dan setiap kali pelanggan anda tambah kredit.": "உங்கள் இணைப்பைப் பகிருங்கள். ஒவ்வொரு உரிம விற்பனைக்கும், வாடிக்கையாளர்கள் கடன்புள்ளி நிரப்பும் ஒவ்வொரு முறையும் தரகு பெறுங்கள்.",
  "Kredit AI anda sudah habis. Tambah kredit di halaman Kredit untuk menjana lagi.": "உங்கள் AI கடன்புள்ளிகள் தீர்ந்துவிட்டன. மேலும் உருவாக்க கடன்புள்ளி பக்கத்தில் நிரப்புங்கள்.",
  "Kredit AI datang bersama lesen.": "AI கடன்புள்ளிகள் உரிமத்துடன் வருகின்றன.",
  "Kredit lesen": "உரிமக் கடன்புள்ளிகள்",
  "Kuiz dijawab": "எடுத்த வினாடி வினாக்கள்",
  "Kuiz terbaik": "சிறந்த வினாடி வினா",
  "Kurang {x}.": "{x} குறைவு.",
  "Laman utama": "முகப்பு",
  "Latihan ({n} soalan)": "பயிற்சி ({n} கேள்விகள்)",
  "Latihan ikut DSKP": "DSKP பயிற்சி",
  "Latihan mengikut format UASA": "UASA வடிவத்தில் பயிற்சி",
  "Lesen": "உரிமம்",
  "Lesen akan diikat pada emel ini.": "உரிமம் இந்த மின்னஞ்சலுடன் இணைக்கப்படும்.",
  "Lesen lifetime anda kini aktif. Selamat belajar!": "உங்கள் வாழ்நாள் உரிமம் இப்போது செயலில் உள்ளது. இனிய கற்றல்!",
  "Lihat JomBelajar": "JomBelajar பார்க்கவும்",
  "Lihat penjana": "உருவாக்கியைப் பார்க்கவும்",
  "Lihat resit": "ரசீதைப் பார்",
  "Lihat semua": "அனைத்தையும் பார்",
  "Link affiliate anda": "உங்கள் இணைப்பாளர் இணைப்பு",
  "Log masuk": "உள்நுழை",
  "Log masuk dengan emel yang digunakan semasa membeli.": "வாங்கும்போது பயன்படுத்திய மின்னஞ்சலுடன் உள்நுழையவும்.",
  "Log masuk dengan emel yang sama digunakan semasa membeli untuk mengaktifkan lesen.": "உரிமத்தைச் செயல்படுத்த, வாங்கும்போது பயன்படுத்திய அதே மின்னஞ்சலுடன் உள்நுழையவும்.",
  "Log masuk sebagai {email}.": "{email} ஆக உள்நுழைந்துள்ளீர்கள்.",
  "Log masuk untuk mula belajar.": "கற்கத் தொடங்க உள்நுழையவும்.",
  "Main": "விளையாடு",
  "Main lagi": "மீண்டும் விளையாடு",
  "Masih dijana (set penuh ambil 2–5 minit). Anda boleh tinggalkan halaman ini.": "இன்னும் உருவாகிறது (முழுத் தொகுப்புக்கு 2–5 நிமிடங்கள்). இந்தப் பக்கத்தை விட்டுச் செல்லலாம்.",
  "Masih dijana. Anda boleh tinggalkan halaman ini; kertas akan muncul dalam senarai.": "இன்னும் உருவாகிறது. இந்தப் பக்கத்தை விட்டுச் செல்லலாம்; தாள் பட்டியலில் தோன்றும்.",
  "Matematik": "கணிதம்",
  "Memuatkan DSKP…": "DSKP ஏற்றப்படுகிறது…",
  "Memuatkan…": "ஏற்றப்படுகிறது…",
  "Mengesahkan pautan…": "இணைப்பைச் சரிபார்க்கிறது…",
  "Menu": "பட்டியல்",
  "Minimum keluar {min} · pindahan bank": "குறைந்தபட்சம் {min} · வங்கிப் பரிமாற்றம்",
  "Mudah": "எளிது",
  "Muka depan, kotak pemeriksa, rajah": "முகப்புப் பக்கம், மதிப்பீட்டாளர் பெட்டிகள், வரைபடங்கள்",
  "Mula belajar": "கற்கத் தொடங்கு",
  "Mula kuiz": "வினாடி வினாவைத் தொடங்கு",
  "Mula — semua unit": "தொடங்கு — அனைத்து அலகுகள்",
  "Mula!": "தொடங்கு!",
  "Nama pembayar (seperti dalam akaun)": "செலுத்துபவர் பெயர் (கணக்கில் உள்ளபடி)",
  "Nama pemegang akaun": "கணக்கு வைத்திருப்பவர் பெயர்",
  "No. akaun": "கணக்கு எண்",
  "No. rujukan transaksi bank / e-wallet": "வங்கி / மின்-பணப்பை பரிவர்த்தனைக் குறிப்பு எண்",
  "Nota dan kuiz ikut DSKP dan KSSR.": "DSKP மற்றும் KSSR அடிப்படையிலான குறிப்புகளும் வினாடி வினாக்களும்.",
  "Nota penting": "முக்கியக் குறிப்புகள்",
  "Nota, latihan dan kuiz": "குறிப்புகள், பயிற்சி மற்றும் வினாடி வினாக்கள்",
  "Nyawa: {n}": "உயிர்கள்: {n}",
  "PDF Kertas + Skema": "தாள் + விடைக் குறிப்பு PDF",
  "PDF tidak dapat dibina untuk kertas ini. Sila laporkan kepada admin.": "இந்தத் தாளுக்கு PDF உருவாக்க முடியவில்லை. நிர்வாகியிடம் தெரிவிக்கவும்.",
  "Padan Kad": "அட்டைப் பொருத்தம்",
  "Pautan log masuk tidak sah atau sudah tamat.": "உள்நுழைவு இணைப்பு செல்லாது அல்லது காலாவதியானது.",
  "Pautan pengaktifan lesen telah dihantar ke {email}. Semak inbox, Spam dan Promosi.": "உரிம செயல்படுத்தல் இணைப்பு {email} க்கு அனுப்பப்பட்டது. இன்பாக்ஸ், ஸ்பேம், விளம்பரக் கோப்புறைகளைச் சரிபார்க்கவும்.",
  "Pautan pengaktifan sudah digunakan.": "செயல்படுத்தல் இணைப்பு ஏற்கனவே பயன்படுத்தப்பட்டது.",
  "Pautan pengaktifan sudah tamat. Hubungi kami untuk pautan baharu.": "செயல்படுத்தல் இணைப்பு காலாவதியானது. புதிய இணைப்புக்கு எங்களைத் தொடர்பு கொள்ளுங்கள்.",
  "Pautan pengaktifan tidak lengkap. Buka semula pautan dari emel anda.": "செயல்படுத்தல் இணைப்பு முழுமையில்லை. உங்கள் மின்னஞ்சலிலிருந்து இணைப்பை மீண்டும் திறக்கவும்.",
  "Pautan pengaktifan tidak sah.": "செல்லாத செயல்படுத்தல் இணைப்பு.",
  "Pecahkan belon dengan jawapan yang betul untuk terbangkan roket ke bulan!": "சரியான பதில் உள்ள பலூனை உடைத்து ராக்கெட்டை நிலவுக்குப் பறக்கவிடுங்கள்!",
  "Pecahkan belon jawapan betul, terbangkan roket!": "சரியான பலூனை உடைத்து ராக்கெட்டை ஏவுங்கள்!",
  "Pelajaran dipelajari": "கற்ற பாடங்கள்",
  "Pelanggan": "வாடிக்கையாளர்",
  "Pelanggan anda topup RM50": "உங்கள் வாடிக்கையாளர் RM50 நிரப்புகிறார்",
  "Pelanggan bayar {price}": "வாடிக்கையாளர் {price} செலுத்துகிறார்",
  "Pelarasan admin": "நிர்வாகச் சரிசெய்தல்",
  "Pelawat link": "இணைப்புப் பார்வையாளர்கள்",
  "Pembeli ke-101 hingga 200": "101 முதல் 200 வரை வாங்குநர்கள்",
  "Pendidikan Islam": "இஸ்லாமியக் கல்வி",
  "Pendidikan Jasmani": "உடற்கல்வி",
  "Pendidikan Kesihatan": "சுகாதாரக் கல்வி",
  "Pendidikan Moral": "நன்னெறிக் கல்வி",
  "Pendidikan Muzik": "இசைக் கல்வி",
  "Pendidikan Seni Visual": "காட்சிக் கலைக் கல்வி",
  "Penerima: {name}. Tulis {ref} dalam ruangan rujukan jika app bank anda membenarkan.": "பெறுநர்: {name}. உங்கள் வங்கிச் செயலி அனுமதித்தால் குறிப்புப் பகுதியில் {ref} என எழுதுங்கள்.",
  "Pengeluaran {amount} (diminta {date}) sedang diproses. Resit akan diemel kepada anda.": "{date} அன்று கோரிய {amount} பணம் எடுப்பு செயலாக்கப்படுகிறது. ரசீது மின்னஞ்சலில் அனுப்பப்படும்.",
  "Pengembaraan Soalan": "கேள்விப் பயணம்",
  "Penjana Kertas": "தாள் உருவாக்கி",
  "Penjana UASA": "UASA உருவாக்கி",
  "Penjana kertas sedang sibuk. Cuba lagi kemudian.": "தாள் உருவாக்கி தற்போது பரபரப்பாக உள்ளது. பின்னர் முயலவும்.",
  "Penjana kertas untuk pemegang lesen.": "தாள் உருவாக்கி உரிமம் உள்ளவர்களுக்கானது.",
  "Penjanaan gagal.": "உருவாக்கம் தோல்வியடைந்தது.",
  "Perkhidmatan AI tidak dapat dihubungi. Kredit anda tidak ditolak.": "AI சேவையை அணுக முடியவில்லை. உங்கள் கடன்புள்ளிகள் கழிக்கப்படவில்லை.",
  "Tahun 1–3": "1–3 ஆம் ஆண்டு",
  "Tahun 4–6": "4–6 ஆம் ஆண்டு",
  "Harga dan pembelian": "விலை மற்றும் வாங்குதல்",
  "Tebus kod": "குறியீட்டை மீட்டெடுக்க",
  "Permainan dan kuiz": "விளையாட்டுகளும் வினாடி வினாவும்",
  "Permainan": "விளையாட்டுகள்",
  "Permainan dimainkan": "விளையாடிய விளையாட்டுகள்",
  "Permainan lain": "மற்ற விளையாட்டுகள்",
  "Permainan memori: padankan soalan dan jawapan.": "நினைவாற்றல் விளையாட்டு: கேள்விகளையும் பதில்களையும் பொருத்துங்கள்.",
  "Permintaan {amount} dihantar. Anda akan terima emel bersama resit sebaik sahaja duit dipindahkan.": "{amount} க்கான கோரிக்கை அனுப்பப்பட்டது. பணம் பரிமாற்றப்பட்டதும் ரசீதுடன் மின்னஞ்சல் வரும்.",
  "Pesanan ini sudah diproses.": "இந்த ஆர்டர் ஏற்கனவே செயலாக்கப்பட்டது.",
  "Pesanan ini tamat kerana tiada bayaran direkodkan. Jika anda sudah bayar, hubungi kami dengan kod rujukan ini.": "கட்டணம் பதிவு செய்யப்படாததால் இந்த ஆர்டர் காலாவதியானது. நீங்கள் செலுத்தியிருந்தால், இந்தக் குறிப்புக் குறியீட்டுடன் எங்களைத் தொடர்பு கொள்ளுங்கள்.",
  "Pesanan tidak dijumpai. Semak kod rujukan dan emel.": "ஆர்டர் கிடைக்கவில்லை. குறிப்புக் குறியீட்டையும் மின்னஞ்சலையும் சரிபார்க்கவும்.",
  "Pesanan {ref}": "ஆர்டர் {ref}",
  "Pilih sifir": "வாய்ப்பாட்டைத் தேர்ந்தெடு",
  "Pilih subjek": "பாடத்தைத் தேர்ந்தெடு",
  "Pilih tahun anda": "உங்கள் ஆண்டைத் தேர்ந்தெடு",
  "Pilih unit dan SP": "அலகுகளையும் கற்றல் தரநிலைகளையும் தேர்ந்தெடு",
  "Pizza Pecahan": "பின்னப் பீட்சா",
  "Pizza dengan {k} daripada {n} potong berlorek": "{n} துண்டுகளில் {k} நிழலிட்ட பீட்சா",
  "Polisi Pembatalan & Refund": "ரத்து மற்றும் பணம் திருப்பக் கொள்கை",
  "Polisi Refund": "பணம் திருப்பக் கொள்கை",
  "Privasi": "தனியுரிமை",
  "Program affiliate terbuka kepada 200 pembeli awal (RM69 / RM79) yang lesennya aktif.": "இணைப்பாளர் திட்டம் செயலில் உள்ள உரிமம் கொண்ட முதல் 200 வாங்குநர்களுக்கு (RM69 / RM79) திறந்துள்ளது.",
  "Program akan dibuka kepada pengguna lain melalui promosi akan datang.": "வரவிருக்கும் சலுகை மூலம் இத்திட்டம் மற்ற பயனர்களுக்கும் திறக்கப்படும்.",
  "Pukul berapa?": "மணி என்ன?",
  "Ralat rangkaian. Cuba lagi.": "பிணையப் பிழை. மீண்டும் முயலவும்.",
  "Ralat sistem. Kredit anda tidak ditolak.": "அமைப்புப் பிழை. உங்கள் கடன்புள்ளிகள் கழிக்கப்படவில்லை.",
  "Ralat tidak dijangka. Cuba lagi.": "எதிர்பாராத பிழை. மீண்டும் முயலவும்.",
  "Reka Bentuk dan Teknologi": "வடிவமைப்பும் தொழில்நுட்பமும்",
  "Resit / screenshot bayaran": "கட்டண ரசீது / திரைப்பிடிப்பு",
  "Resit mesti gambar (JPG/PNG/WEBP) atau PDF.": "ரசீது படமாக (JPG/PNG/WEBP) அல்லது PDF ஆக இருக்க வேண்டும்.",
  "Resit tidak dapat dibuka. Cuba lagi.": "ரசீதைத் திறக்க முடியவில்லை. மீண்டும் முயலவும்.",
  "Rujukan bank ini sudah digunakan untuk pesanan lain.": "இந்த வங்கிக் குறிப்பு ஏற்கனவே வேறொரு ஆர்டருக்குப் பயன்படுத்தப்பட்டது.",
  "Rujukan: {ref}": "குறிப்பு: {ref}",
  "Sahkan emel anda dahulu.": "முதலில் உங்கள் மின்னஞ்சலை உறுதிப்படுத்தவும்.",
  "Sains": "அறிவியல்",
  "Salah": "தவறு",
  "Salin link": "இணைப்பை நகலெடு",
  "Satu lesen, semua modul, akses seumur hidup.": "ஒரு உரிமம், அனைத்து தொகுதிகள், வாழ்நாள் அணுகல்.",
  "Satu pautan, satu akaun, sekali guna.": "ஒரு இணைப்பு, ஒரு கணக்கு, ஒருமுறை பயன்பாடு.",
  "Saya bersetuju dengan": "நான் ஒப்புக்கொள்கிறேன்:",
  "Saya sudah bayar": "நான் செலுத்திவிட்டேன்",
  "Sedang dijana…": "உருவாகிறது…",
  "Sederhana": "நடுத்தரம்",
  "Pengeluaran diproses setiap {n} hari (2 minggu sekali)": "ஒவ்வொரு {n} நாட்களுக்கும் (2 வாரத்திற்கு ஒரு முறை) பணம் எடுப்பு செயலாக்கப்படும்",
  "Pengeluaran dibayar setiap 2 minggu sekali. Permohonan dibayar pada pusingan seterusnya.": "பணம் எடுப்பு 2 வாரத்திற்கு ஒரு முறை வழங்கப்படும். கோரிக்கைகள் அடுத்த சுற்றில் செலுத்தப்படும்.",
  "Sedia dikeluarkan": "எடுக்கத் தயார்",
  "Sedia untuk kuiz?": "வினாடி வினாவுக்குத் தயாரா?",
  "Sejarah": "வரலாறு",
  "Sejarah kredit": "கடன்புள்ளி வரலாறு",
  "Selesai": "முடிந்தது",
  "Semak emel anda. Pautan sah selama 15 minit. Log masuk di peranti baharu akan menamatkan sesi lama.": "உங்கள் மின்னஞ்சலைப் பாருங்கள். இணைப்பு 15 நிமிடங்களுக்குச் செல்லும். புதிய சாதனத்தில் உள்நுழைந்தால் பழைய அமர்வு முடியும்.",
  "Semakan jawapan": "விடைச் சரிபார்ப்பு",
  "Semua subjek": "அனைத்து பாடங்கள்",
  "Semua subjek · Tahun 1–6": "அனைத்து பாடங்கள் · ஆண்டு 1–6",
  "Set format UASA": "UASA வடிவத் தொகுப்பு",
  "Set soalan format UASA": "UASA வடிவக் கேள்வித் தொகுப்பு",
  "Set soalan format UASA untuk semua subjek Tahun 1–6, atau latihan ikut DSKP.": "அனைத்து பாடங்களுக்கும் ஆண்டு 1–6 UASA வடிவக் கேள்வித் தொகுப்புகள், அல்லது DSKP பயிற்சி.",
  "Seterusnya": "அடுத்து",
  "Sifir Roket": "பெருக்கல் ராக்கெட்",
  "Sila lampirkan resit atau screenshot bayaran.": "கட்டண ரசீது அல்லது திரைப்பிடிப்பை இணைக்கவும்.",
  "Sila log masuk.": "தயவுசெய்து உள்நுழையவும்.",
  "Sila semak maklumat yang dimasukkan.": "நீங்கள் உள்ளிட்ட விவரங்களைச் சரிபார்க்கவும்.",
  "Sila tunggu…": "தயவுசெய்து காத்திருக்கவும்…",
  "Simpan akaun bank": "வங்கிக் கணக்கைச் சேமி",
  "Simpan akaun bank anda dahulu.": "முதலில் உங்கள் வங்கிக் கணக்கைச் சேமிக்கவும்.",
  "Simpan akaun bank anda di atas dahulu.": "முதலில் மேலே உங்கள் வங்கிக் கணக்கைச் சேமிக்கவும்.",
  "Skema jawapan": "விடைக் குறிப்பு",
  "Skema jawapan berasingan": "தனி விடைக் குறிப்பு",
  "Slot Early Bird anda disimpan selama {time} lagi.": "உங்கள் முன்பதிவு இடம் இன்னும் {time} வைக்கப்படும்.",
  "Slot Early Bird pesanan ini telah dilepaskan.": "இந்த ஆர்டரின் முன்பதிவு இடம் விடுவிக்கப்பட்டது.",
  "Soalan ditanda dengan kod SP": "கேள்விகளில் கற்றல் தரநிலைக் குறியீடு",
  "Soalan {i} daripada {n}": "கேள்வி {i} / {n}",
  "Standard": "நிலையானது",
  "Standard Pembelajaran (DSKP)": "கற்றல் தரநிலைகள் (DSKP)",
  "Standard Pembelajaran ({n}/{max} dipilih)": "கற்றல் தரநிலைகள் ({n}/{max} தேர்வு)",
  "Status": "நிலை",
  "Subjek": "பாடம்",
  "Sudah bayar?": "செலுத்திவிட்டீர்களா?",
  "Sudah dibayar": "செலுத்தப்பட்டது",
  "Tahap": "நிலை",
  "Tahun": "ஆண்டு",
  "Tahun / Tingkatan": "ஆண்டு / படிவம்",
  "Tahun 1 hingga 6": "ஆண்டு 1 முதல் 6 வரை",
  "Tahun {n}": "ஆண்டு {n}",
  "Tambah kertas": "தாள்களைச் சேர்",
  "Tambah kredit": "கடன்புள்ளி நிரப்பு",
  "Tambah {n} kertas dengan {price}.": "{price} க்கு {n} தாள்கள் சேர்க்கவும்.",
  "Tambah {n} kertas — {price}": "{n} தாள்கள் சேர் — {price}",
  "Tanpa had": "வரம்பற்றது",
  "Tarikh": "தேதி",
  "Teka pecahan pizza yang berlorek.": "பீட்சாவின் நிழலிட்ட பின்னத்தைக் கண்டுபிடியுங்கள்.",
  "Tekan duit di bawah untuk bayar.": "செலுத்த கீழே உள்ள பணத்தைத் தட்டுங்கள்.",
  "Tempoh pesanan tamat": "ஆர்டர் காலாவதியானது",
  "Tempoh pesanan telah tamat. Sila buat pesanan baharu.": "ஆர்டர் காலாவதியானது. புதிய ஆர்டர் செய்யவும்.",
  "Tempoh simpanan tamat. Jika anda sudah bayar, hantar rujukan sekarang.": "வைத்திருக்கும் நேரம் முடிந்தது. நீங்கள் செலுத்தியிருந்தால், இப்போதே குறிப்பைச் சமர்ப்பிக்கவும்.",
  "Terbalikkan dua kad. Padankan setiap soalan (biru) dengan jawapannya (kuning).": "இரண்டு அட்டைகளைத் திருப்புங்கள். ஒவ்வொரு கேள்வியையும் (நீலம்) அதன் பதிலுடன் (மஞ்சள்) பொருத்துங்கள்.",
  "Terima kasih! Bayaran anda sedang disemak. Pautan pengaktifan akan dihantar ke {email} sebaik sahaja disahkan (biasanya dalam masa beberapa jam pada waktu bekerja). Halaman ini dikemas kini secara automatik. Emel kadang-kadang masuk ke folder Spam atau Promosi, jadi sila semak di situ juga.": "நன்றி! உங்கள் கட்டணம் சரிபார்க்கப்படுகிறது. உறுதிப்படுத்தியதும் செயல்படுத்தல் இணைப்பு {email} க்கு அனுப்பப்படும் (பொதுவாக வேலை நேரத்தில் சில மணிநேரங்களில்). இந்தப் பக்கம் தானாகப் புதுப்பிக்கப்படும். மின்னஞ்சல் சில நேரங்களில் ஸ்பேம் அல்லது விளம்பரக் கோப்புறைக்குச் செல்லலாம்; அங்கும் சரிபார்க்கவும்.",
  "Terima kasih! Kredit akan ditambah sebaik sahaja bayaran disahkan (biasanya dalam hari yang sama).": "நன்றி! கட்டணம் உறுதியானதும் கடன்புள்ளிகள் சேர்க்கப்படும் (பொதுவாக அதே நாளில்).",
  "Terlalu banyak cubaan. Cuba lagi sebentar.": "அதிக முயற்சிகள். சிறிது நேரத்தில் மீண்டும் முயலவும்.",
  "Terlalu ramai sedang membuat bayaran. Cuba lagi dalam beberapa minit.": "இப்போது பலர் கட்டணம் செலுத்துகின்றனர். சில நிமிடங்களில் மீண்டும் முயலவும்.",
  "Terlebih {x}. Cuba kira semula.": "{x} அதிகம். மீண்டும் எண்ணிப் பாருங்கள்.",
  "Terma": "விதிமுறைகள்",
  "Terma & Syarat": "விதிமுறைகளும் நிபந்தனைகளும்",
  "Tertahan": "நிறுத்தி வைக்கப்பட்டது",
  "Tertahan {n} hari (tempoh refund)": "{n} நாட்கள் நிறுத்தி வைக்கப்படும் (பணம் திருப்பக் காலம்)",
  "Teruskan ke bayaran": "கட்டணத்திற்குத் தொடர்க",
  "Tiada rekod lagi.": "இன்னும் பதிவுகள் இல்லை.",
  "Tiada soalan untuk pilihan ini lagi.": "இந்தத் தேர்வுக்கு இன்னும் கேள்விகள் இல்லை.",
  "Tiada subjek untuk tahun ini lagi.": "இந்த ஆண்டுக்கு இன்னும் பாடங்கள் இல்லை.",
  "Tidak dijawab": "பதிலளிக்கப்படவில்லை",
  "Tinggal {n} slot": "{n} இடங்கள் மீதம்",
  "Tingkatan {n}": "படிவம் {n}",
  "Topup kredit": "கடன்புள்ளி நிரப்புதல்",
  "Topup pelanggan": "வாடிக்கையாளர் நிரப்புதல்கள்",
  "Tukar": "மாற்று",
  "Tukar bahasa": "மொழியை மாற்று",
  "Tukar ke tema cerah": "வெளிர் தோற்றத்திற்கு மாற்று",
  "Tukar ke tema gelap": "இருண்ட தோற்றத்திற்கு மாற்று",
  "Tutup": "மூடு",
  "UASA, nota, kuiz dan PDF dalam satu platform.": "UASA, குறிப்புகள், வினாடி வினாக்கள், PDF அனைத்தும் ஒரே தளத்தில்.",
  "Unit": "அலகுகள்",
  "Unit yang diuji ({n}/{max})": "சோதிக்கப்படும் அலகுகள் ({n}/{max})",
  "Utama": "முதன்மை",
  "Utama (mudah alih)": "முதன்மை (கைபேசி)",
  "Versi": "பதிப்பு",
  "Waktu pagi. Apakah waktu dalam sistem 24 jam?": "காலை நேரம். 24 மணி நேர முறையில் நேரம் என்ன?",
  "Waktu petang/malam. Apakah waktu dalam sistem 24 jam?": "மாலை/இரவு நேரம். 24 மணி நேர முறையில் நேரம் என்ன?",
  "atau pilih satu unit": "அல்லது ஒரு அலகைத் தேர்ந்தெடுங்கள்",
  "dan": "மற்றும்",
  "dwibahasa": "இருமொழி",
  "isian": "நிரப்புதல்",
  "padanan": "பொருத்துதல்",
  "tanda ✓/×": "சரி / தவறு குறி",
  "jawapan pendek": "குறுவிடை",
  "kertas": "தாள்கள்",
  "kertas lagi boleh dijana": "தாள்கள் இன்னும் உருவாக்கலாம்",
  "objektif": "புறவயம்",
  "pelajaran": "பாடங்கள்",
  "pelajaran selesai": "பாடங்கள் முடிந்தன",
  "rujukan {ref}": "குறிப்பு {ref}",
  "sen": "சென்",
  "struktur": "கட்டமைப்பு",
  "susun ayat": "வாக்கிய அமைப்பு",
  "tanpa had": "வரம்பற்றது",
  "unit": "அலகுகள்",
  "unit sedia": "அலகுகள் தயார்",
  "untuk melihat kredit anda.": "உங்கள் கடன்புள்ளிகளைப் பார்க்க.",
  "untuk melihat link affiliate anda.": "உங்கள் இணைப்பாளர் இணைப்பைப் பார்க்க.",
  "untuk menjana kertas.": "தாள்களை உருவாக்க.",
  "versi English": "ஆங்கிலப் பதிப்பு",
  "{amount} lagi masih tertahan ({n} hari selepas jualan) dan akan masuk ke baki secara automatik.": "மேலும் {amount} இன்னும் நிறுத்தி வைக்கப்பட்டுள்ளது (விற்பனைக்குப் பின் {n} நாட்கள்); தானாக இருப்பில் சேரும்.",
  "{a} kumpulan, setiap satu ada {b}": "{a} குழுக்கள், ஒவ்வொன்றிலும் {b}",
  "{m} markah, {d} minit": "{m} மதிப்பெண்கள், {d} நிமிடங்கள்",
  "{n} hari selepas jualan": "விற்பனைக்குப் பின் {n} நாட்கள்",
  "{n} langkah": "{n} நகர்வுகள்",
  "{price} untuk {n} kertas. Lesen anda kekal sama.": "{n} தாள்களுக்கு {price}. உங்கள் உரிமம் மாறாது.",
  "Lapor masalah": "சிக்கலைப் புகாரளி",
  "Terangkan apa yang berlaku. Halaman semasa dihantar sekali supaya kami boleh semak.": "என்ன நடந்தது என்பதை விவரிக்கவும். நாங்கள் சரிபார்க்க தற்போதைய பக்கமும் சேர்த்து அனுப்பப்படும்.",
  "Contoh: Butang muat turun skema tak jalan untuk Sains Tahun 4.": "உதாரணம்: அறிவியல் ஆண்டு 4-க்கான விடைத்திட்டப் பதிவிறக்கப் பொத்தான் வேலை செய்யவில்லை.",
  "Terima kasih! Laporan anda sudah dihantar.": "நன்றி! உங்கள் புகார் அனுப்பப்பட்டது.",
  "Laporan tidak dapat dihantar. Cuba lagi.": "புகாரை அனுப்ப முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  "Simpan gambar QR": "QR படத்தைச் சேமி",
  "Guna telefon? Simpan gambar QR, kemudian buka app bank atau e-wallet → DuitNow QR → pilih gambar dari galeri.": "கைபேசியா? QR படத்தைச் சேமித்து, உங்கள் வங்கி அல்லது மின்-பணப்பை செயலியைத் திறந்து → DuitNow QR → கேலரியிலிருந்து படத்தைத் தேர்ந்தெடுக்கவும்.",
  "Tadika · 4–6 tahun": "பாலர் பள்ளி · 4–6 வயது",
  "Jom Baca": "வாசிப்போம்",
  "8 tahap suku kata: dari a-i-u hingga baca cerita.": "8 அசை நிலைகள்: a-i-u முதல் கதை வாசிப்பு வரை.",
  "Mula": "தொடங்கு",
  "Tadika: Jom Baca": "பாலர் பள்ளி: வாசிப்போம்",
  "Belajar membaca dengan kaedah suku kata, 8 tahap. Untuk umur 4–6 tahun.": "அசை முறையில் மலாய் வாசிக்கக் கற்றல், 8 நிலைகள். 4–6 வயதினருக்கு.",
  "Untuk ibu bapa: duduk bersama anak. Tekan suku kata untuk dengar bunyinya, minta anak sebut semula, kemudian main permainan di setiap tahap.": "பெற்றோருக்கு: குழந்தையுடன் அமருங்கள். அசையைத் தட்டி ஒலியைக் கேளுங்கள், குழந்தையைத் திரும்பச் சொல்லச் சொல்லுங்கள், பின்னர் ஒவ்வொரு நிலையிலும் விளையாட்டுகளை விளையாடுங்கள்.",
  "Peranti ini tidak menyokong bunyi. Bacakan suku kata untuk anak.": "இந்தச் சாதனம் ஒலியை ஆதரிக்கவில்லை. அசைகளைக் குழந்தைக்கு வாசித்துக் காட்டுங்கள்.",
  "Tahap {n}": "நிலை {n}",
  "Tahap tidak dijumpai.": "நிலை கிடைக்கவில்லை.",
  "Kembali ke tahap": "நிலைக்குத் திரும்பு",
  "Suku kata": "அசைகள்",
  "Perkataan": "சொற்கள்",
  "Baca ayat": "வாக்கியங்களை வாசி",
  "Cerita": "கதைகள்",
  "Baca dan jawab {n} soalan": "வாசித்து {n} கேள்விகளுக்குப் பதிலளி",
  "Jom main": "விளையாடுவோம்",
  "Cantum suku kata": "அசைகளை இணை",
  "Susun suku kata ikut gambar.": "படத்திற்கு ஏற்ப அசைகளை வரிசைப்படுத்து.",
  "Pilih gambar": "படத்தைத் தேர்ந்தெடு",
  "Baca perkataan, tekan gambar yang betul.": "சொல்லை வாசித்து, சரியான படத்தைத் தட்டு.",
  "Tahap seterusnya": "அடுத்த நிலை",
  "tekan untuk dengar": "கேட்கத் தட்டு",
  "Dengar ayat": "வாக்கியத்தைக் கேள்",
  "Pandai! Teruskan membaca.": "அருமை! தொடர்ந்து வாசி.",
  "Dengar": "கேள்",
  "Tekan gambar untuk dengar perkataan.": "சொல்லைக் கேட்கப் படத்தைத் தட்டு.",
  "Dengar cerita": "கதையைக் கேள்",
  "Jawab soalan": "கேள்விகளுக்குப் பதிலளி",
  "Suara: {name}": "குரல்: {name}",
  "Uji suara": "குரலைச் சோதி",
  "Telefon ini tiada suara Bahasa Melayu, jadi bunyi dimatikan supaya sebutan tidak salah.": "இந்தக் கைபேசியில் மலாய் குரல் இல்லை, தவறான உச்சரிப்பைத் தவிர்க்க ஒலி அணைக்கப்பட்டுள்ளது.",
  "iPhone/iPad: Settings → Accessibility → Spoken Content → Voices → Malay (atau Indonesian) → muat turun.": "iPhone/iPad: Settings → Accessibility → Spoken Content → Voices → Malay (அல்லது Indonesian) → பதிவிறக்கு.",
  "Android: Settings → Bahasa & input → Output teks-ke-pertuturan → Google → Pasang data suara → Bahasa Melayu (atau Indonesia).": "Android: Settings → Language & input → Text-to-speech output → Google → Install voice data → Malay (அல்லது Indonesian).",
  "Selepas itu tutup dan buka semula pelayar. Sementara itu, bacakan suku kata untuk anak.": "பின்னர் உலாவியை மூடி மீண்டும் திறக்கவும். அதுவரை அசைகளைக் குழந்தைக்கு வாசித்துக் காட்டுங்கள்.",
  "Audio sebutan JomCerdik": "JomCerdik உச்சரிப்பு ஒலி",
  "Kira Gambar": "படங்களை எண்ணு",
  "Kira gambar, kemudian tekan jawapan yang betul.": "படங்களை எண்ணி, சரியான விடையைத் தட்டு.",
  "Tambah gambar": "படங்களைக் கூட்டு",
  "Kira gambar": "படங்களை எண்ணு",
  "Tekan gambar untuk mengira: satu, dua, tiga…": "எண்ணப் படங்களைத் தட்டு: ஒன்று, இரண்டு, மூன்று…",
  "Kenal huruf": "எழுத்துகள்",
  "Huruf apa?": "எந்த எழுத்து?",
  "Cari huruf": "எழுத்தைக் கண்டுபிடி",
  "Celik Jawi": "ஜாவி வாசிப்பு",
  "37 huruf Jawi. Tekan huruf untuk dengar namanya.": "37 ஜாவி எழுத்துகள். பெயரைக் கேட்க எழுத்தைத் தட்டு.",
  "Huruf apakah ini?": "இது எந்த எழுத்து?",
  "Cari huruf ini:": "இந்த எழுத்தைக் கண்டுபிடி:",
  "Mewarna": "வண்ணம் தீட்டு",
  "Pilih warna, kemudian tekan bahagian gambar.": "வண்ணத்தைத் தேர்ந்தெடுத்து, படத்தின் ஒரு பகுதியைத் தட்டு.",
  "Gambar lain": "மற்ற படங்கள்",
  "Undur": "செயல்தவிர்",
  "Padam semua": "அனைத்தையும் அழி",
  "Simpan gambar": "படத்தைச் சேமி",
  "Matematik tadika: kira dan tambah.": "பாலர் கணிதம்: எண்ணுதல், கூட்டல்.",
  "Kenal huruf Jawi dan bunyinya.": "ஜாவி எழுத்துகளையும் ஒலிகளையும் அறி.",
  "Pilih warna, tekan gambar.": "வண்ணத்தைத் தேர்ந்து, படத்தைத் தட்டு.",
  "Permainan Tadika": "பாலர் விளையாட்டுகள்",
  "Jom Baca: 8 tahap": "வாசிப்போம்: 8 நிலைகள்",
  "Pentaksiran Tahun 1–3 (PBD) dan set format UASA Tahun 4–6, atau latihan ikut DSKP.": "ஆண்டு 1–3 வகுப்பறை மதிப்பீடு (PBD), ஆண்டு 4–6 UASA வடிவத் தேர்வுத் தொகுப்புகள் அல்லது DSKP அடிப்படையிலான பயிற்சி.",
  "Pentaksiran & UASA": "மதிப்பீடு & UASA",
  "Tahun 1–3: latihan pentaksiran PBD": "ஆண்டு 1–3: PBD வகுப்பறை மதிப்பீட்டுப் பயிற்சி",
  "Tahun 4–6: set format UASA": "ஆண்டு 4–6: UASA வடிவத் தேர்வுத் தொகுப்புகள்",
  "Set latihan pentaksiran Tahun 1–3 (PBD)": "ஆண்டு 1–3 வகுப்பறை மதிப்பீட்டு (PBD) பயிற்சித் தொகுப்புகள்",
  "Tahun 1–3 menggunakan pentaksiran bilik darjah (PBD), bukan format UASA rasmi KPM. Semak kesesuaian soalan sebelum digunakan.": "ஆண்டு 1–3 இல் வகுப்பறை மதிப்பீடு (PBD) பயன்படுத்தப்படுகிறது; கல்வி அமைச்சின் அதிகாரப்பூர்வ UASA வடிவம் அல்ல. பயன்படுத்தும் முன் வினாக்களின் பொருத்தத்தைச் சரிபார்க்கவும்.",
  // ── Dunia 3D (peta, dunia tahun, aktiviti, demo) ──
  "KECIL LANGKAHNYA. BESAR DUNIANYA.": "சிறிய அடிகள். பெரிய உலகம்.",
  "Belajar jadi": "கற்றல் ஒரு",
  "satu pengembaraan.": "சாகசமாகிறது.",
  "Enam dunia untuk diteroka. Seribu sebab untuk rasa ingin tahu.": "ஆராய ஆறு உலகங்கள். ஆர்வமாக இருக்க ஆயிரம் காரணங்கள்.",
  "Jom teroka": "வாருங்கள் ஆராய்வோம்",
  "Latihan UASA": "UASA பயிற்சி",
  "PILIH PENGEMBARAAN KAMU": "உங்கள் சாகசத்தைத் தேர்ந்தெடுங்கள்",
  "Hari ini, ke dunia mana?": "இன்று எந்த உலகத்திற்கு?",
  "JomBelajar sebenar →": "உண்மையான JomBelajar →",
  "Sentuhan portal menggerakkan maskot dan kamera sebelum dunia dibuka.": "நுழைவாயிலைத் தொட்டால் உலகம் திறக்கும் முன் சின்னங்களும் கேமராவும் நகரும்.",
  "Istana Ajaib": "மாய அரண்மனை",
  "Langkah pertama, penemuan besar.": "முதல் அடி, பெரிய கண்டுபிடிப்புகள்.",
  "Taman Fantasi": "கற்பனைத் தோட்டம்",
  "Ilmu berkembang di setiap sudut.": "ஒவ்வொரு மூலையிலும் அறிவு வளர்கிறது.",
  "Hutan Pengembaraan": "சாகசக் காடு",
  "Ikuti denai. Temui jawapannya.": "பாதையைப் பின்தொடருங்கள். விடைகளைக் கண்டறியுங்கள்.",
  "Dunia Angkasa": "விண்வெளி உலகம்",
  "Bawa rasa ingin tahu ke orbit.": "உங்கள் ஆர்வத்தை சுற்றுப்பாதைக்கு எடுத்துச் செல்லுங்கள்.",
  "Bandar Ilmu": "அறிவு நகரம்",
  "Bina idea, satu demi satu.": "ஒவ்வொன்றாக யோசனைகளை உருவாக்குங்கள்.",
  "Dunia Futuristik": "எதிர்கால உலகம்",
  "Bersedia untuk pengembaraan seterusnya.": "அடுத்த சாகசத்திற்குத் தயாராகுங்கள்.",
  "Buku cerita & huruf": "கதைப் புத்தகங்கள் & எழுத்துகள்",
  "Words & conversations": "சொற்கள் & உரையாடல்கள்",
  "Nombor, bentuk & idea": "எண்கள், வடிவங்கள் & யோசனைகள்",
  "Eksperimen & penemuan": "சோதனைகள் & கண்டுபிடிப்புகள்",
  "Kisah, peta & garis masa": "கதைகள், வரைபடங்கள் & காலவரிசை",
  "Berapakah 6 + 7?": "6 + 7 என்பது என்ன?",
  "Bahagian tumbuhan manakah menyerap air?": "தாவரத்தின் எந்தப் பகுதி நீரை உறிஞ்சுகிறது?",
  "Bilakah Persekutuan Tanah Melayu mencapai kemerdekaan?": "மலாயா கூட்டமைப்பு எப்போது சுதந்திரம் பெற்றது?",
  "Bunga": "பூ",
  "Daun": "இலை",
  "Akar": "வேர்",
  "Batang": "தண்டு",
  "Air": "நீர்",
  "Cahaya": "ஒளி",
  "Tumbuh": "வளர்",
  "Kini": "இப்போது",
  "Dunia tidak ditemui": "உலகம் கிடைக்கவில்லை",
  "Kembali ke peta": "வரைபடத்துக்குத் திரும்பு",
  "← Semua dunia": "← அனைத்து உலகங்களும்",
  "PENGEMBARAAN TAHUN {n}": "ஆண்டு {n} சாகசம்",
  "Kandungan tahun ini →": "இந்த ஆண்டின் உள்ளடக்கம் →",
  "Mari teroka {name}.": "{name} ஆராய்வோம்.",
  "Dua cara untuk belajar": "கற்க இரண்டு வழிகள்",
  "Aktiviti dunia ialah simulasi interaktif untuk semakan reka bentuk. Nota, unit dan kemajuan sebenar kekal di JomBelajar dan memerlukan lesen aktif.": "உலகச் செயல்பாடுகள் வடிவமைப்பு மதிப்பாய்வுக்கான ஊடாடும் உருவகப்படுத்தல்கள். உண்மையான குறிப்புகள், அலகுகள், முன்னேற்றம் JomBelajar-இல் இருக்கும்; செயலில் உள்ள உரிமம் தேவை.",
  "Jawi Tadika →": "மழலையர் ஜாவி →",
  "Cuba aliran UASA →": "UASA செயல்முறையை முயற்சிக்கவும் →",
  "Permainan sebenar →": "உண்மையான விளையாட்டுகள் →",
  "Mencari kandungan tahun ini…": "இந்த ஆண்டின் உள்ளடக்கத்தைத் தேடுகிறது…",
  "Kandungan belum dapat dimuat. Gunakan pautan JomBelajar.": "உள்ளடக்கத்தை இன்னும் ஏற்ற முடியவில்லை. JomBelajar இணைப்பைப் பயன்படுத்துங்கள்.",
  "Aktiviti tidak tersedia": "செயல்பாடு கிடைக்கவில்லை",
  "← Dunia Tahun {n}": "← ஆண்டு {n} உலகம்",
  "AKTIVITI CONTOH · DATA SIMULASI": "மாதிரிச் செயல்பாடு · உருவகப்படுத்தப்பட்ட தரவு",
  "Buka unit sebenar →": "உண்மையான அலகைத் திறக்கவும் →",
  "PENEMUAN {n}": "கண்டுபிடிப்பு {n}",
  "Cuba apa yang kamu pelajari": "நீங்கள் கற்றதை முயற்சிக்கவும்",
  "Sentuh. Susun. Temui.": "தொடுங்கள். அடுக்குங்கள். கண்டறியுங்கள்.",
  "Sentuh setiap bahagian tumbuhan, kemudian jalankan eksperimen air.": "தாவரத்தின் ஒவ்வொரு பகுதியையும் தொட்டு, பின்னர் நீர் சோதனையை நடத்துங்கள்.",
  "Teroka peristiwa pada garis masa mengikut urutan.": "காலவரிசையில் நிகழ்வுகளை வரிசைப்படி ஆராயுங்கள்.",
  "Sentuh kad untuk melihat respons maskot dan susunan baharu.": "அட்டையைத் தொட்டு சின்னங்களின் எதிர்வினையையும் புதிய அடுக்கையும் பாருங்கள்.",
  "{item} — bagus, teruskan meneroka!": "{item} — அருமை, தொடர்ந்து ஆராயுங்கள்!",
  "Teroka lagi →": "மேலும் ஆராயுங்கள் →",
  "Susunan berubah. Mari cuba sekali lagi.": "அடுக்கு மாறியது. மீண்டும் முயல்வோம்.",
  "KUIZ CONTOH": "மாதிரி வினாடி வினா",
  "Betul! Hebat usaha kamu!": "சரி! உங்கள் முயற்சி அருமை!",
  "Belum tepat. Cuba lagi, kami temankan.": "இன்னும் சரியில்லை. மீண்டும் முயலுங்கள், நாங்கள் உடனிருக்கிறோம்.",
  "Betul! Kamu berjaya.": "சரி! நீங்கள் வெற்றி பெற்றீர்கள்.",
  "Belum tepat. Cuba pilihan lain.": "இன்னும் சரியில்லை. வேறு விருப்பத்தை முயலுங்கள்.",
  "Nota dan kuiz sebenar dalam JomBelajar →": "உண்மையான குறிப்புகளும் வினாடி வினாக்களும் JomBelajar-இல் →",
  "SIMULASI REKA BENTUK · TIADA KREDIT DITOLAK": "வடிவமைப்பு உருவகப்படுத்தல் · கடன்புள்ளி கழிக்கப்படாது",
  "Meja persediaan UASA": "UASA தயாரிப்பு மேசை",
  "Tetapan → proses → kertas tersedia → pratonton.": "அமைப்புகள் → செயலாக்கம் → தாள் தயார் → முன்னோட்டம்.",
  "Jana kertas contoh": "மாதிரித் தாளை உருவாக்கு",
  "Menyediakan kertas contoh… {n}%": "மாதிரித் தாளைத் தயாரிக்கிறது… {n}%",
  "SIMULASI · BUKAN KERTAS PEPERIKSAAN RASMI": "உருவகப்படுத்தல் · அதிகாரப்பூர்வ தேர்வுத் தாள் அல்ல",
  "Latihan contoh {subject} Tahun {year}": "{subject} மாதிரிப் பயிற்சி, ஆண்டு {year}",
  "Nama: _____________________ Tarikh: ______________": "பெயர்: _____________________ தேதி: ______________",
  "Lihat jawapan": "விடையைப் பார்க்கவும்",
  "Cetak contoh": "மாதிரியை அச்சிடு",
  "Buka penjana UASA sebenar →": "உண்மையான UASA உருவாக்கியைத் திறக்கவும் →",
  "Menyusun kertas contoh. Tunggu sehingga pratonton tersedia.": "மாதிரித் தாளைத் தயாரிக்கிறோம். முன்னோட்டம் தயாராகும் வரை காத்திருங்கள்.",
  "Kertas contoh sudah tersedia untuk dipratonton.": "மாதிரித் தாள் முன்னோட்டத்திற்குத் தயார்.",
  "DASHBOARD CONTOH · SEMUA REKOD DI BAWAH ADALAH SIMULASI": "மாதிரி டாஷ்போர்டு · கீழுள்ள அனைத்துப் பதிவுகளும் உருவகப்படுத்தப்பட்டவை",
  "Usaha dikongsi, ilmu bertambah.": "முயற்சி பகிரப்படுகிறது, அறிவு வளர்கிறது.",
  "Pembeli awal yang layak boleh mempromosikan lesen baharu melalui referral.": "தகுதியுள்ள ஆரம்பகால வாங்குபவர்கள் பரிந்துரை மூலம் புதிய உரிமங்களை விளம்பரப்படுத்தலாம்.",
  "Dashboard contoh": "மாதிரி டாஷ்போர்டு",
  "referral": "பரிந்துரை",
  "jualan": "விற்பனை",
  "komisen": "தரகு",
  "Paparan {tab} contoh dibuka.": "மாதிரி {tab} காட்சி திறக்கப்பட்டது.",
  "Pautan referral contoh": "மாதிரி பரிந்துரை இணைப்பு",
  "CONTOH-KOD-ANDA": "மாதிரி-உங்கள்-குறியீடு",
  "Ini kod demonstrasi. Pautan sebenar hanya tersedia dalam akaun affiliate yang layak.": "இது ஒரு விளக்கக் குறியீடு. உண்மையான இணைப்பு தகுதியுள்ள இணைப்பாளர் கணக்கில் மட்டுமே கிடைக்கும்.",
  "Kod contoh disalin": "மாதிரிக் குறியீடு நகலெடுக்கப்பட்டது",
  "Salin kod contoh": "மாதிரிக் குறியீட்டை நகலெடு",
  "Rekod jualan simulasi": "உருவகப்படுத்தப்பட்ட விற்பனைப் பதிவுகள்",
  "Rujukan": "குறிப்பு எண்",
  "Dalam tempoh tahanan": "நிறுத்தி வைக்கப்பட்ட காலத்தில்",
  "Diluluskan — contoh": "அங்கீகரிக்கப்பட்டது — மாதிரி",
  "Komisen contoh": "மாதிரி தரகு",
  "JUALAN CONTOH": "மாதிரி விற்பனை",
  "KOMISEN SETIAP JUALAN*": "ஒவ்வொரு விற்பனைக்கும் தரகு*",
  "TEMPOH TAHANAN": "நிறுத்தி வைக்கும் காலம்",
  "{n} hari": "{n} நாட்கள்",
  "*Contoh pembeli lesen RM{n}. Peraturan sebenar menggunakan harga lesen dan kelayakan akaun.": "*RM{n} உரிமம் வாங்குபவருக்கான எடுத்துக்காட்டு. உண்மையான விதிகள் உரிம விலையையும் கணக்குத் தகுதியையும் அடிப்படையாகக் கொண்டவை.",
  "Buka dashboard affiliate sebenar →": "உண்மையான இணைப்பாளர் டாஷ்போர்டைத் திறக்கவும் →",
  "SEMAKAN ASET & AKSI": "சொத்து & செயல் மதிப்பாய்வு",
  "Kenali Aiman dan Aina.": "Aiman மற்றும் Aina-வைச் சந்தியுங்கள்.",
  "Pilih aksi di bawah. Kami akan menghadap kamu selepas meneroka, dan duduk di kerusi bersama meja serta buku apabila membaca atau menulis.": "கீழே ஒரு செயலைத் தேர்ந்தெடுங்கள். ஆராய்ந்த பிறகு நாங்கள் உங்களை நோக்கித் திரும்புவோம்; படிக்கும்போதோ எழுதும்போதோ மேசை, புத்தகத்துடன் நாற்காலியில் அமர்வோம்.",
  "Idle / bernafas": "சும்மா / சுவாசம்",
  "Berkelip": "கண் சிமிட்டுதல்",
  "Berjalan": "நடத்தல்",
  "Berlari": "ஓடுதல்",
  "Melambai": "கை அசைத்தல்",
  "Menunjuk": "சுட்டிக்காட்டுதல்",
  "Melompat": "குதித்தல்",
  "Duduk & membaca": "அமர்ந்து படித்தல்",
  "Menulis": "எழுதுதல்",
  "Meraikan": "கொண்டாடுதல்",
  "Jawapan betul": "சரியான விடை",
  "Galakan": "ஊக்கம்",
  "Menoleh": "திரும்பிப் பார்த்தல்",
  "Aksi: {name}": "செயல்: {name}",
  "Peta dunia →": "உலக வரைபடம் →",
  "Aliran UASA →": "UASA செயல்முறை →",
  "Dashboard affiliate contoh →": "மாதிரி இணைப்பாளர் டாஷ்போர்டு →",
  "Hai! Kami Aiman dan Aina. Jom teroka bersama.": "வணக்கம்! நாங்கள் Aiman மற்றும் Aina. சேர்ந்து ஆராய்வோம்.",
  "Jom masuk portal Tahun {n}!": "ஆண்டு {n} நுழைவாயிலுக்குள் செல்வோம்!",
  "Dunia Tahun {n} dibuka. Pilih kawasan subjek di bawah.": "ஆண்டு {n} உலகம் திறந்தது. கீழே ஒரு பாடப் பகுதியைத் தேர்ந்தெடுங்கள்.",
  "Peranti ini tidak dapat memaparkan WebGL. Gunakan pilihan tahun dan semua aktiviti di bawah.": "இந்தச் சாதனத்தால் WebGL-ஐக் காட்ட முடியவில்லை. கீழே உள்ள ஆண்டு விருப்பங்களையும் அனைத்துச் செயல்பாடுகளையும் பயன்படுத்துங்கள்.",
  "Enjin 3D tidak dapat dimuat. Cuba semula; navigasi biasa masih tersedia.": "3D இயந்திரத்தை ஏற்ற முடியவில்லை. மீண்டும் முயலுங்கள்; வழக்கமான வழிசெலுத்தல் இன்னும் கிடைக்கும்.",
  "Semak pautan, jualan dan komisen dalam akaun kamu.": "உங்கள் கணக்கில் இணைப்புகள், விற்பனை, தரகைப் பாருங்கள்.",
  "Pilih tetapan kertas. Pratonton hanya muncul apabila kertas tersedia.": "தாள் அமைப்புகளைத் தேர்ந்தெடுங்கள். தாள் தயாரான பின்னரே முன்னோட்டம் தோன்றும்.",
  "Kami temankan. Ikut panduan pada borang di bawah.": "நாங்கள் உடனிருக்கிறோம். கீழுள்ள படிவத்தின் வழிகாட்டலைப் பின்பற்றுங்கள்.",
  "Pilih subjek dan mulakan penemuan baharu.": "ஒரு பாடத்தைத் தேர்ந்தெடுத்து புதிய கண்டுபிடிப்பைத் தொடங்குங்கள்.",
  "Sedikit demi sedikit, kamu pasti boleh!": "கொஞ்சம் கொஞ்சமாக, உங்களால் முடியும்!",
  "DUNIA PEMBELAJARAN 3D": "3D கற்றல் உலகம்",
  "PRATONTON STAGING": "ஸ்டேஜிங் முன்னோட்டம்",
  "Dunia 3D bersama Aiman dan Aina": "Aiman மற்றும் Aina உடன் 3D உலகம்",
  "Enam pulau pembelajaran dan dua maskot 3D. Gunakan butang tahun di bawah untuk akses papan kekunci.": "ஆறு கற்றல் தீவுகளும் இரண்டு 3D சின்னங்களும். விசைப்பலகை அணுகலுக்கு கீழே உள்ள ஆண்டு பொத்தான்களைப் பயன்படுத்துங்கள்.",
  "Menyiapkan dunia dan dua maskot…": "உலகத்தையும் இரண்டு சின்னங்களையும் தயாரிக்கிறது…",
  "Cuba semula 3D": "3D-ஐ மீண்டும் முயல்க",
  "Pilih dunia": "உலகத்தைத் தேர்ந்தெடுங்கள்",
  "Sapa maskot": "சின்னங்களை வாழ்த்துங்கள்",
  "Maskot melambai": "சின்னங்கள் கை அசைக்கின்றன",
  "Hai! Pilih satu portal untuk mula.": "வணக்கம்! தொடங்க ஒரு நுழைவாயிலைத் தேர்ந்தெடுங்கள்.",
  "Sambung animasi": "அனிமேஷனைத் தொடரவும்",
  "Jeda animasi": "அனிமேஷனை இடைநிறுத்து",
  "Menuju portal…": "நுழைவாயிலை நோக்கிச் செல்கிறது…",
  "Sentuh portal bercahaya atau pilih dunia di bawah": "ஒளிரும் நுழைவாயிலைத் தொடுங்கள் அல்லது கீழே ஒரு உலகத்தைத் தேர்ந்தெடுங்கள்",
  "Model {file} tidak dapat dimuat. Cuba semula paparan 3D.": "{file} மாதிரியை ஏற்ற முடியவில்லை. 3D காட்சியை மீண்டும் முயலுங்கள்.",
  "Paparan 3D terhenti. Navigasi dan aktiviti masih boleh digunakan. Cuba muat semula paparan.": "3D காட்சி நின்றுவிட்டது. வழிசெலுத்தலும் செயல்பாடுகளும் இன்னும் செயல்படும். காட்சியை மீண்டும் ஏற்றிப் பாருங்கள்.",
  "Dunia 1–6": "உலகங்கள் 1–6",
  "PRATONTON DUNIA JOMCERDIK · BELAJAR SAMBIL MENEROKA": "JOMCERDIK உலக முன்னோட்டம் · ஆராய்ந்தபடி கற்றுக்கொள்ளுங்கள்",
  "Uji 13 aksi maskot →": "13 சின்னச் செயல்களைச் சோதிக்கவும் →",
  "Pautan lain": "மற்ற இணைப்புகள்",
  "Tadika": "மழலையர் பள்ளி",
  "Jawi": "ஜாவி",
  "Kira": "எண்ணுதல்",
  "Harga & pembelian": "விலை மற்றும் வாங்குதல்",
  "Redeem": "ரிடீம்",
  "Kredit": "கடன்புள்ளி",
  "Refund": "பணம் திரும்பப் பெறுதல்",
  "Kertas sedang dijana. Tunggu status sebenar sebelum membuka pratonton.": "தாள் உருவாக்கப்படுகிறது. முன்னோட்டத்தைத் திறக்கும் முன் உண்மையான நிலைக்காகக் காத்திருங்கள்.",
  "Kertas siap! Buka kertas yang tersedia dalam senarai.": "தாள் தயார்! பட்டியலில் உள்ள தாளைத் திறக்கவும்.",
  "Cuba lagi. Kamu boleh belajar daripada jawapan tadi.": "மீண்டும் முயலுங்கள். சற்று முன் வந்த விடைகளிலிருந்து நீங்கள் கற்றுக்கொள்ளலாம்.",
  "Betul! Hebat usaha kamu.": "சரி! உங்கள் முயற்சி அருமை.",
  "Cuba lagi, kamu boleh!": "மீண்டும் முயலுங்கள், உங்களால் முடியும்!",
  "Akaun saya": "என் கணக்கு",
  "Aktif": "செயலில்",
  "Belum aktif": "இன்னும் செயலில் இல்லை",
  "Tetapkan kata laluan": "கடவுச்சொல்லை அமைக்கவும்",
  "Tukar kata laluan": "கடவுச்சொல்லை மாற்றவும்",
  "Kata laluan baharu": "புதிய கடவுச்சொல்",
  "Sahkan kata laluan": "கடவுச்சொல்லை உறுதிப்படுத்தவும்",
  "Sekurang-kurangnya 8 aksara.": "குறைந்தது 8 எழுத்துகள்.",
  "Kata laluan sekurang-kurangnya 8 aksara.": "கடவுச்சொல் குறைந்தது 8 எழுத்துகள் இருக்க வேண்டும்.",
  "Kata laluan tidak sama.": "கடவுச்சொற்கள் பொருந்தவில்லை.",
  "Kata laluan disimpan. Lain kali anda boleh log masuk dengan emel dan kata laluan.": "கடவுச்சொல் சேமிக்கப்பட்டது. அடுத்த முறை மின்னஞ்சல் மற்றும் கடவுச்சொல்லுடன் உள்நுழையலாம்.",
  "Simpan": "சேமி",
  "Tetapkan kata laluan supaya lain kali anda boleh log masuk tanpa menunggu emel.": "கடவுச்சொல்லை அமைத்தால் அடுத்த முறை மின்னஞ்சலுக்குக் காத்திருக்காமல் உள்நுழையலாம்.",
  "Tetapkan sekarang": "இப்போதே அமைக்கவும்",
  "Masukkan emel dan kata laluan anda.": "உங்கள் மின்னஞ்சல் மற்றும் கடவுச்சொல்லை உள்ளிடவும்.",
  "Kami hantar pautan log masuk sekali guna ke emel anda. Guna ini kali pertama atau jika terlupa kata laluan.": "உங்கள் மின்னஞ்சலுக்கு ஒருமுறை பயன்படுத்தும் உள்நுழைவு இணைப்பை அனுப்புவோம். முதல் முறை அல்லது கடவுச்சொல்லை மறந்தால் இதைப் பயன்படுத்தவும்.",
  "Kata laluan": "கடவுச்சொல்",
  "Kali pertama atau lupa kata laluan? Hantar pautan ke emel": "முதல் முறையா அல்லது கடவுச்சொல் மறந்துவிட்டதா? மின்னஞ்சலுக்கு இணைப்பை அனுப்பவும்",
  "Log masuk dengan kata laluan": "கடவுச்சொல்லுடன் உள்நுழைக",
  "Emel atau kata laluan salah. Belum ada kata laluan? Guna pautan emel.": "மின்னஞ்சல் அல்லது கடவுச்சொல் தவறு. கடவுச்சொல் இல்லையா? மின்னஞ்சல் இணைப்பைப் பயன்படுத்தவும்.",
  "Terlalu banyak cubaan salah. Cuba lagi dalam 15 minit atau guna pautan emel.": "பல தவறான முயற்சிகள். 15 நிமிடங்களுக்குப் பிறகு முயலவும் அல்லது மின்னஞ்சல் இணைப்பைப் பயன்படுத்தவும்.",
  "Masukkan emel anda. Kami hantar pautan untuk anda tetapkan kata laluan baharu.": "உங்கள் மின்னஞ்சலை உள்ளிடவும். புதிய கடவுச்சொல்லை அமைக்க இணைப்பை அனுப்புவோம்.",
  "Hantar pautan tetapan semula": "மீட்டமைப்பு இணைப்பை அனுப்பு",
  "Lupa kata laluan?": "கடவுச்சொல்லை மறந்துவிட்டீர்களா?",
  "Kali pertama? Hantar pautan ke emel": "முதல் முறையா? மின்னஞ்சலுக்கு இணைப்பை அனுப்பவும்",
  "Semak emel anda. Klik pautan untuk log masuk, kemudian tetapkan kata laluan baharu. Pautan sah selama 15 minit.": "உங்கள் மின்னஞ்சலைப் பாருங்கள். இணைப்பைக் கிளிக் செய்து உள்நுழைந்து புதிய கடவுச்சொல்லை அமைக்கவும். இணைப்பு 15 நிமிடங்கள் செல்லுபடியாகும்.",
  "Kertas belum lulus semakan kandungan atau tulisan. Kredit anda tidak ditolak.": "தாளின் உள்ளடக்கம் அல்லது எழுத்துமுறை சரிபார்ப்பு நிறைவடையவில்லை. உங்கள் தாள் கடன் கழிக்கப்படவில்லை.",
  "Gambar belum berjaya dijana. Kertas belum disiapkan dan kredit anda tidak ditolak.": "படங்களை உருவாக்க முடியவில்லை. தாள் நிறைவடையாததால் உங்கள் கடன் கழிக்கப்படவில்லை.",
  "Gambar kertas belum dapat dimuat turun. Sila cuba muat turun semula.": "தாளின் படங்களைப் பதிவிறக்க முடியவில்லை. மீண்டும் பதிவிறக்க முயலவும்.",
  "Tahun 1–6": "ஆண்டு 1–6",
  "Belajar dengan lebih seronok bersama JomCerdik": "JomCerdik உடன் மேலும் மகிழ்ச்சியாகக் கற்கலாம்",
  "Nota, audio, aktiviti, kuiz dan kertas UASA untuk Tadika hingga Tahun 6.": "மழலையர் முதல் ஆண்டு 6 வரை குறிப்புகள், ஒலி, செயல்பாடுகள், வினாடி வினா, UASA தாள்கள்.",
  "Akses pantas ke modul pembelajaran": "கற்றல் தொகுதிகளுக்கு விரைவு அணுகல்",
  "Kategori Tadika": "மழலையர் வகைகள்",
  "Cari modul, subjek atau kategori…": "தொகுதி, பாடம் அல்லது வகையைத் தேடுங்கள்…",
  "Cari": "தேடு",
  "Berapa banyak?": "எத்தனை?",
  "Apakah huruf pertama?": "முதல் எழுத்து என்ன?",
  "Pilih warna": "நிறத்தைத் தேர்ந்தெடுங்கள்",
  "Pilih bentuk": "வடிவத்தைத் தேர்ந்தெடுங்கள்",
  "Sentuh": "தொடுங்கள்",
  "Kategori tidak dijumpai.": "வகை கிடைக்கவில்லை.",
  "Semua kategori": "அனைத்து வகைகளும்",
  "Mula latihan": "பயிற்சியைத் தொடங்கு",
  "Tekan gambar untuk dengar": "கேட்க படத்தைத் தொடுங்கள்",
  "Kira gambar dan tekan untuk dengar": "படங்களை எண்ணி, கேட்கத் தொடுங்கள்",
  "Dengar lagi": "மீண்டும் கேளுங்கள்",
  "Adi, murid tadika": "ஆதி, மழலையர் மாணவன்",
  "Betul! Bagus!": "சரி! நன்று!",
  "Dengar soalan": "கேள்வியைக் கேளுங்கள்",
  "Gambar untuk dikira": "எண்ண வேண்டிய படங்கள்",
  "Lihat keputusan": "முடிவுகளைப் பார்",
  "Tahniah!": "வாழ்த்துகள்!",
  "betul pada cubaan pertama": "முதல் முயற்சியிலேயே சரி",
  "Kategori pembelajaran": "கற்றல் வகைகள்",
  "Jana Kertas": "தாள் உருவாக்கு",
  "Pilih tahun, subjek, format dan topik.": "ஆண்டு, பாடம், வடிவம், தலைப்பைத் தேர்ந்தெடுக்கவும்.",
  "Latihan Dalam Talian": "இணையப் பயிற்சி",
  "Pratonton, jawab dan semak jawapan terus.": "முன்னோட்டம் பார்த்து, பதிலளித்து உடனே சரிபார்க்கவும்.",
  "Kertas Saya": "என் தாள்கள்",
  "Muat turun PDF kertas dan skema.": "தாள், விடைத்திட்டத்தை PDF ஆகப் பதிவிறக்கவும்.",
  "Keputusan dan Laporan": "முடிவுகளும் அறிக்கையும்",
  "Markah, bintang dan kertas yang perlu diulang.": "மதிப்பெண், நட்சத்திரங்கள், மீண்டும் செய்ய வேண்டிய தாள்கள்.",
  "UASA lebih mudah, lebih teratur": "UASA எளிதாகவும் ஒழுங்காகவும்",
  "Bahagian UASA": "UASA பிரிவுகள்",
  "Kertas siap boleh dijawab dalam talian di bahagian Latihan Dalam Talian.": "முடிந்த தாள்களை இணையப் பயிற்சியில் பதிலளிக்கலாம்.",
  "Buka latihan": "பயிற்சியைத் திற",
  "Belum ada kertas siap. Jana kertas dahulu.": "முடிந்த தாள் இல்லை. முதலில் உருவாக்கவும்.",
  "Belum ada keputusan. Selesaikan satu latihan dalam talian.": "முடிவுகள் இல்லை. ஒரு இணையப் பயிற்சியை முடிக்கவும்.",
  "Purata markah": "சராசரி மதிப்பெண்",
  "{n} latihan diselesaikan": "{n} பயிற்சிகள் முடிந்தன",
  "Perlu diulang": "மீண்டும் செய்ய வேண்டும்",
  "Lihat semakan": "சரிபார்ப்பைப் பார்",
  "Latihan dalam talian": "இணையத்தில் பயிற்சி",
  "Rajah soalan ini ada dalam PDF kertas.": "இந்தக் கேள்வியின் படம் PDF தாளில் உள்ளது.",
  "Pratonton kertas. {n} soalan objektif boleh dijawab dalam talian; soalan lain ada dalam PDF.": "தாள் முன்னோட்டம். {n} objektif கேள்விகளை இணையத்தில் பதிலளிக்கலாம்; மற்றவை PDF-இல்.",
  "Jawapan anda": "உங்கள் பதில்",
  "Pilih bahagian badan": "உடல் பாகத்தைத் தேர்ந்தெடுக்கவும்",
  "Bintang": "நட்சத்திரங்கள்",
  "Pilih satu bahagian badan untuk bermula.": "தொடங்க ஒரு உடல் பாகத்தைத் தேர்ந்தெடுக்கவும்.",
  "pada badan Adi.": "ஆதியின் உடலில்.",
  "Kemajuan": "முன்னேற்றம்",
  "Baca suku kata dan perkataan.": "அசைகளையும் சொற்களையும் படிக்கவும்.",
  "Main sambil belajar.": "விளையாடிக்கொண்டே கற்கவும்.",
  "Modul Pembelajaran": "கற்றல் பகுதிகள்",
  "Soalan": "கேள்வி",
  "Apakah nama bahagian ini?": "இந்த உடல் பாகத்தின் பெயர் என்ன?",
  "Tekan untuk dengar sebutan": "உச்சரிப்பைக் கேட்கத் தொடவும்",
  "Ulang Audio": "மீண்டும் ஒலி",
  "Belajar · Bermain · Jadi Lebih Bijak": "கற்போம் · விளையாடுவோம் · புத்திசாலியாவோம்",
  "Hai, Adik!": "வணக்கம் குட்டி!",
  "Teruskan belajar hari ini": "இன்றும் தொடர்ந்து கற்போம்",
  "Kemajuan Pembelajaran": "கற்றல் முன்னேற்றம்",
  "{a} / {b} modul": "{a} / {b} பகுதிகள்",
  "Bintang Terkumpul": "சேர்த்த நட்சத்திரங்கள்",
  "Kenal huruf besar dan kecil dengan gambar.": "படங்களுடன் பெரிய, சிறிய எழுத்துகளை அறிவோம்.",
  "Kira gambar dan pilih nombor yang betul.": "படங்களை எண்ணி சரியான எண்ணைத் தேர்ந்தெடுக்கவும்.",
  "Padankan warna dengan benda di sekeliling.": "நிறங்களைச் சுற்றியுள்ள பொருட்களுடன் பொருத்துக.",
  "Kenal bulat, segi tiga, segi empat dan lain-lain.": "வட்டம், முக்கோணம், சதுரம் மற்றும் பிறவற்றை அறிவோம்.",
  "Sentuh bahagian badan dan dengar namanya.": "உடல் பாகத்தைத் தொட்டு பெயரைக் கேளுங்கள்.",
  "Kenal haiwan dan bunyinya.": "விலங்குகளையும் அவற்றின் ஒலிகளையும் அறிவோம்.",
  "Kenal buah tempatan yang sedap.": "சுவையான உள்ளூர் பழங்களை அறிவோம்.",
  "Makanan dan minuman yang kita suka.": "நாம் விரும்பும் உணவும் பானமும்.",
  "Kenderaan di darat, laut dan udara.": "நிலம், கடல், வானில் செல்லும் வாகனங்கள்.",
  "Kenal matahari, awan, pokok dan alam sekeliling.": "சூரியன், மேகம், மரம், இயற்கையை அறிவோம்.",
  "Kenal pekerjaan dan tugas mereka.": "தொழில்களையும் அவர்கள் பணிகளையும் அறிவோம்.",
  "Kenal perasaan: gembira, sedih, marah dan lain-lain.": "உணர்வுகள்: மகிழ்ச்சி, சோகம், கோபம் மற்றும் பிறவை.",
  "Tambah profil anak supaya kemajuan setiap anak disimpan dan boleh dipantau.": "குழந்தைகளின் சுயவிவரங்களைச் சேர்த்தால் ஒவ்வொருவரின் முன்னேற்றமும் சேமிக்கப்பட்டுக் கண்காணிக்கலாம்.",
  "Siapa belajar hari ini?": "இன்று யார் கற்கிறார்?",
  "Urus anak": "குழந்தைகளை நிர்வகி",
  "Anak": "குழந்தைகள்",
  "Sudah mencapai had bilangan anak untuk satu akaun.": "ஒரு கணக்கிற்கான குழந்தைகளின் எண்ணிக்கை வரம்பை அடைந்துவிட்டீர்கள்.",
  "Belum dipilih": "இன்னும் தேர்வு செய்யப்படவில்லை",
  "Belum mula": "இன்னும் தொடங்கவில்லை",
  "Log masuk untuk menambah anak dan melihat perkembangan mereka.": "குழந்தைகளைச் சேர்க்கவும் அவர்களின் முன்னேற்றத்தைப் பார்க்கவும் உள்நுழையவும்.",
  "Padam {name}? Sejarah belajarnya disimpan tetapi tidak lagi dipaparkan.": "{name} ஐ நீக்கவா? கற்றல் வரலாறு சேமிக்கப்படும், ஆனால் இனி காட்டப்படாது.",
  "Akaun ibu bapa": "பெற்றோர் கணக்கு",
  "Anak-anak saya": "என் குழந்தைகள்",
  "Tambah nama anak, pilih maskot, dan lihat perkembangan setiap seorang.": "ஒவ்வொரு குழந்தையின் பெயரையும் சேர்த்து, சின்னத்தைத் தேர்ந்தெடுத்து, முன்னேற்றத்தைப் பாருங்கள்.",
  "Perempuan": "பெண்",
  "Lelaki": "ஆண்",
  "{n} nota": "{n} குறிப்புகள்",
  "{n} kuiz": "{n} வினாடி வினாக்கள்",
  "Lihat perkembangan": "முன்னேற்றம் பார்",
  "Sedang belajar": "இப்போது கற்கிறார்",
  "Pilih": "தேர்வு",
  "Ubah": "திருத்து",
  "Padam": "நீக்கு",
  "+ Tambah anak": "+ குழந்தையைச் சேர்",
  "Sudah mencapai had {n} anak.": "{n} குழந்தைகள் என்ற வரம்பை அடைந்துவிட்டீர்கள்.",
  "Sila masukkan nama anak.": "குழந்தையின் பெயரை உள்ளிடவும்.",
  "Ubah maklumat anak": "குழந்தையின் விவரங்களைத் திருத்து",
  "Tambah anak": "குழந்தையைச் சேர்",
  "Nama anak": "குழந்தையின் பெயர்",
  "Pilih maskot": "சின்னத்தைத் தேர்ந்தெடு",
  "Tahap persekolahan": "பள்ளி நிலை",
  "Semua anak": "எல்லா குழந்தைகளும்",
  "Nota dibaca": "படித்த குறிப்புகள்",
  "Kuiz diambil": "எடுத்த வினாடி வினாக்கள்",
  "Purata markah kuiz": "சராசரி வினாடி வினா மதிப்பெண்",
  "Permainan dimain": "விளையாடிய விளையாட்டுகள்",
  "14 hari terakhir": "கடந்த 14 நாட்கள்",
  "Aktiviti belajar 14 hari terakhir": "கடந்த 14 நாட்களின் கற்றல் செயல்பாடு",
  "Penguasaan mengikut subjek": "பாடத்தின்படி தேர்ச்சி",
  "Belum ada kuiz. Minta {name} cuba kuiz pertama.": "இன்னும் வினாடி வினா இல்லை. {name} முதல் வினாடி வினாவை முயற்சிக்கட்டும்.",
  "Perlu diperbaiki": "மேம்படுத்த வேண்டியவை",
  "Cadangan: bantu {name} mengulang kaji {subject} dahulu.": "பரிந்துரை: முதலில் {name} {subject} ஐ மீள்பார்வை செய்ய உதவுங்கள்.",
  "Kuiz terkini": "சமீபத்திய வினாடி வினாக்கள்",
  "Ruang melukis ada dalam PDF kertas.": "வரைவதற்கான இடம் தாளின் PDF-இல் உள்ளது.",
  "Pratonton kertas. {n} soalan boleh dijawab terus dalam talian (pilih A, B, C).": "தாள் முன்னோட்டம். {n} கேள்விகளை இங்கேயே ஆன்லைனில் பதிலளிக்கலாம் (A, B, C தேர்வு).",
  "{n} bahagian": "{n} பகுதிகள்",
  "Soalan menulis panjang boleh ditaip, tetapi tidak digalakkan. Untuk latihan menulis, jana kertas UASA atau DSKP (PDF) dan jawab di atas kertas.": "நீண்ட எழுத்துக் கேள்விகளை தட்டச்சு செய்யலாம், ஆனால் பரிந்துரைக்கப்படுவதில்லை. எழுதிப் பயிற்சி செய்ய UASA அல்லது DSKP தாளை (PDF) உருவாக்கி காகிதத்தில் பதிலளிக்கவும்.",
  "Jawapan menulis panjang tidak digalakkan di sini. Lebih baik jana kertas UASA atau DSKP (PDF) untuk latihan bertulis.": "நீண்ட எழுத்துப் பதில்கள் இங்கே பரிந்துரைக்கப்படுவதில்லை. எழுத்துப் பயிற்சிக்கு UASA அல்லது DSKP தாளை (PDF) உருவாக்குவது நல்லது.",
  "Tunjuk jawapan contoh": "மாதிரி பதிலைக் காட்டு",
  "Jawapan contoh": "மாதிரி பதில்",
  "Untuk soalan menulis panjang, jana kertas UASA atau DSKP (PDF).": "நீண்ட எழுத்துக் கேள்விகளுக்கு UASA அல்லது DSKP தாளை (PDF) உருவாக்கவும்.",
  "Gambar soalan ini ada dalam PDF kertas.": "இந்தக் கேள்வியின் படம் தாளின் PDF-இல் உள்ளது.",
  "Menyediakan pilihan jawapan…": "பதில் தேர்வுகளைத் தயாரிக்கிறது…",
  "Bayar dengan FPX / kad": "FPX / கார்டு மூலம் செலுத்துங்கள்",
  "Terus ke internet banking anda. Disahkan secara automatik — tak perlu hantar resit.": "நேரடியாக உங்கள் ஆன்லைன் வங்கிக்குச் செல்லுங்கள். தானாக உறுதிசெய்யப்படும் — ரசீது தேவையில்லை.",
  "Bayar sekarang (FPX / kad)": "இப்போது செலுத்துங்கள் (FPX / கார்டு)",
  "Menyemak bayaran…": "கட்டணத்தைச் சரிபார்க்கிறது…",
  "Kami sedang mengesahkan bayaran anda dengan Stripe. Halaman ini dikemas kini sendiri — jangan tutup.": "உங்கள் கட்டணத்தை Stripe உடன் உறுதிசெய்கிறோம். இப்பக்கம் தானாகப் புதுப்பிக்கும் — மூட வேண்டாம்.",
  "atau bayar dengan DuitNow QR di bawah": "அல்லது கீழே DuitNow QR மூலம் செலுத்துங்கள்",
  "Bayar guna DuitNow QR (manual, perlu hantar resit)": "DuitNow QR மூலம் செலுத்துங்கள் (கைமுறை, ரசீது தேவை)",
  "Masukkan emel anda. Kami hantar pautan pengesahan, kemudian anda tetapkan kata laluan dan terus ke pembayaran.": "உங்கள் மின்னஞ்சலை உள்ளிடுங்கள். உறுதிப்படுத்தும் இணைப்பை அனுப்புவோம்; பின்னர் கடவுச்சொல்லை அமைத்து நேரடியாகக் கட்டணத்திற்குச் செல்லுங்கள்.",
  "Hantar pautan pengesahan": "உறுதிப்படுத்தும் இணைப்பை அனுப்பு",
  "Semak emel anda dan klik pautan untuk teruskan ke pembayaran. Pautan sah selama 15 minit.": "உங்கள் மின்னஞ்சலைப் பார்த்து, கட்டணத்தைத் தொடர இணைப்பைக் கிளிக் செய்யுங்கள். இணைப்பு 15 நிமிடங்கள் செல்லுபடியாகும்.",
  "Sudah ada akaun? Log masuk": "ஏற்கனவே கணக்கு உள்ளதா? உள்நுழையவும்",
  "Lesen anda sudah aktif": "உங்கள் உரிமம் செயலில் உள்ளது",
  "Terima kasih! Semua modul boleh digunakan sekarang.": "நன்றி! எல்லா தொகுதிகளையும் இப்போது பயன்படுத்தலாம்.",
  "Belum nampak lesen? Muat semula halaman ini, atau hubungi kami dengan emel akaun anda.": "உரிமம் இன்னும் தெரியவில்லையா? இப்பக்கத்தை மீண்டும் ஏற்றவும், அல்லது உங்கள் கணக்கு மின்னஞ்சலுடன் எங்களைத் தொடர்பு கொள்ளவும்.",
  "Akaun: {email}": "கணக்கு: {email}",
  "Sekurang-kurangnya 8 aksara. Anda guna ini untuk log masuk lain kali.": "குறைந்தது 8 எழுத்துகள். அடுத்த முறை உள்நுழைய இதைப் பயன்படுத்துவீர்கள்.",
  "Sebentar sahaja.": "ஒரு கணம்.",
  "Tambah": "கூட்டல்",
  "Tolak": "கழித்தல்",
  "Campur": "கலப்பு",
  "Belon": "பலூன்",
  "Eja": "எழுத்துக்கூட்டு",
  "Padan": "பொருத்து",
  "Pecah Belon": "பலூன் உடை",
  "Tekan belon yang ada jawapan betul.": "சரியான விடையுள்ள பலூனைத் தட்டு.",
  "Matematik: tambah dan tolak.": "கணிதம்: கூட்டல், கழித்தல்.",
  "Asingkan Sains": "அறிவியல் பிரி",
  "Pilih topik, kemudian jawab dengan gambar.": "தலைப்பைத் தேர்ந்து, படங்களைப் பார்த்து விடையளி.",
  "Sains: haiwan, tumbuhan dan pancaindera.": "அறிவியல்: விலங்குகள், தாவரங்கள், புலன்கள்.",
  "Eja Perkataan": "சொல்லை எழுத்துக்கூட்டு",
  "Lihat gambar, kemudian susun huruf.": "படத்தைப் பார்த்து, எழுத்துகளை அடுக்கு.",
  "Susun huruf untuk eja perkataan.": "எழுத்துகளை அடுக்கிச் சொல்லை உருவாக்கு.",
  "Buka dua kad dan cari pasangan yang sama.": "இரண்டு அட்டைகளைத் திறந்து, பொருந்தும் ஜோடியைக் கண்டுபிடி.",
  "Cari pasangan yang sama.": "பொருந்தும் ஜோடிகளைக் கண்டுபிடி.",
  "Huruf besar dan kecil": "பெரிய, சிறிய எழுத்துகள்",
  "Gambar dan perkataan": "படங்களும் சொற்களும்",
  "Langkah: {n}": "நகர்வுகள்: {n}",
  "Betul! Pandai!": "சரி! நன்று!",
  "Kuiz": "வினாடி வினா",
  "Jeda": "இடைநிறுத்து",
  "Organ": "உறுப்புகள்",
  "Suhu": "வெப்பநிலை",
  "Kedudukan": "இடம்",
  "Satu edaran": "ஒரு சுற்று",
  "Makan lagi": "மீண்டும் சாப்பிடு",
  "Makan!": "சாப்பிடு!",
  "Zum keluar": "சிறிதாக்கு",
  "Pilih makanan": "உணவைத் தேர்ந்தெடு",
  "Perjalanan Makanan": "உணவுப் பயணம்",
  "Sistem Suria": "சூரியக் குடும்பம்",
  "Sistem pencernaan manusia": "மனித செரிமான மண்டலம்",
  "Pilih makanan, kemudian tekan Makan!": "உணவைத் தேர்ந்தெடுத்து, சாப்பிடு! அழுத்தவும்",
  "Ikut makanan masuk ke dalam badan. Tekan organ untuk zum.": "உணவு உடலுக்குள் செல்வதைப் பின்தொடர். உறுப்பைத் தொட்டு பெரிதாக்கு.",
  "Ikut makanan melalui sistem pencernaan. Tekan organ untuk zum.": "உணவை செரிமான மண்டலம் வழியாகப் பின்தொடர். உறுப்பைத் தொட்டு பெரிதாக்கு.",
  "Titik hijau ialah asid dalam perut.": "பச்சைப் புள்ளிகள் வயிற்றில் உள்ள அமிலம்.",
  "Makanan yang tidak diperlukan oleh badan keluar sebagai najis.": "உடலுக்குத் தேவையில்லாத உணவு கழிவாக வெளியேறும்.",
  "Planet mengelilingi Matahari. Tekan planet untuk zum.": "கோள்கள் சூரியனைச் சுற்றுகின்றன. கோளைத் தொட்டு பெரிதாக்கு.",
  "Planet beredar mengelilingi Matahari. Tekan planet untuk zum.": "கோள்கள் சூரியனைச் சுற்றுகின்றன. கோளைத் தொட்டு பெரிதாக்கு.",
  "Semakin jauh planet dari Matahari, semakin lama masa untuk beredar satu kali.": "கோள் சூரியனிலிருந்து தொலைவில் இருந்தால், ஒரு சுற்றுக்கு அதிக நேரம் ஆகும்.",
  "Seret untuk putar. Cubit untuk zum.": "இழுத்துச் சுழற்று. இரு விரலால் பெரிதாக்கு.",
  "Fotosintesis": "ஒளிச்சேர்க்கை",
  "Beri pokok air, CO₂ dan cahaya matahari. Lihat ia membesar.": "மரத்துக்கு நீர், கார்பன் டையாக்சைடு, சூரிய ஒளி கொடு. அது வளர்வதைப் பார்.",
  "Main semula": "மீண்டும் விளையாடு",
  "Peranti ini tidak menyokong 3D. Baca penerangan dan cuba kuiz.": "இந்தச் சாதனம் 3D-ஐ ஆதரிக்காது. விளக்கத்தைப் படித்து வினாடி வினாவை முயற்சிக்கவும்.",
  "Baru": "புதியது",
  "Padan Warna": "நிறங்களைப் பொருத்து",
  "Tarik garisan: padankan warna dengan namanya.": "கோடு வரைந்து: நிறத்தை அதன் பெயருடன் பொருத்துங்கள்.",
  "Besar dan Kecil": "பெரியது மற்றும் சிறியது",
  "Tarik garisan: padankan huruf kecil dengan huruf besar.": "கோடு வரைந்து: சிறிய எழுத்தை பெரிய எழுத்துடன் பொருத்துங்கள்.",
  "Padan Binatang": "விலங்குகளைப் பொருத்து",
  "Tarik garisan: sambung dua bahagian binatang.": "கோடு வரைந்து: விலங்கின் இரு பாதிகளையும் இணையுங்கள்.",
  "Padan Pekerjaan": "தொழில்களைப் பொருத்து",
  "Tarik garisan: padankan gambar dengan nama pekerjaan.": "கோடு வரைந்து: படத்தை தொழிலின் பெயருடன் பொருத்துங்கள்.",
  "Tarik dari kiri ke kanan, atau ketik kiri kemudian kanan.": "இடமிருந்து வலமாக இழுக்கவும், அல்லது இடதைத் தட்டி பின் வலதைத் தட்டவும்.",
  "Padan Kenderaan": "வாகனங்களைப் பொருத்து",
  "Tarik garisan: padankan gambar dengan nama kenderaan.": "கோடு வரைந்து: படத்தை வாகனத்தின் பெயருடன் பொருத்துங்கள்.",
  "Padan Buah": "பழங்களைப் பொருத்து",
  "Tarik garisan: padankan gambar dengan nama buah.": "கோடு வரைந்து: படத்தை பழத்தின் பெயருடன் பொருத்துங்கள்.",
  "Space Math": "Space Math",
  "Medan permainan angkasa": "விண்வெளி விளையாட்டுப் பகுதி",
  "Gerakkan kapal, kemudian tekan Tembak pada batu angkasa yang ada jawapan betul. Jika tembak yang salah, batu itu akan hentam kapal!": "கப்பலை நகர்த்தி, சரியான பதில் உள்ள விண்வெளிப் பாறையை நோக்கி 'சுடு' பொத்தானை அழுத்துங்கள். தவறானதைச் சுட்டால் அது உங்கள் கப்பலில் மோதும்!",
  "Gerakkan kapal dan tembak batu angkasa yang ada jawapan betul. Tahun 1–6.": "கப்பலை நகர்த்தி சரியான பதில் உள்ள விண்வெளிப் பாறையைச் சுடுங்கள். ஆண்டு 1–6.",
  "Tembak": "சுடு",
  "Geser jari pada skrin untuk gerakkan kapal ke bawah batu angkasa yang betul, kemudian tekan Tembak.": "திரையில் விரலை நகர்த்தி கப்பலை சரியான விண்வெளிப் பாறைக்குக் கீழே கொண்டு சென்று 'சுடு' அழுத்துங்கள்.",
  "Kart Kuiz": "கார்ட் வினா",
  "Pandu kart 3D bersama Harraz atau Hannah. Pilih lorong jawapan betul untuk boost!": "Harraz அல்லது Hannah உடன் 3D கார்ட் ஓட்டுங்கள். சரியான பதில் வழியைத் தேர்ந்தெடுத்தால் வேகம் கூடும்!",
  "Matematik & Sains": "கணிதம் & அறிவியல்",
  "Pilih pemandu": "ஓட்டுநரைத் தேர்ந்தெடுங்கள்",
  "Topik": "தலைப்பு",
  "Peranti ini tidak menyokong grafik 3D untuk permainan ini.": "இந்தச் சாதனம் இந்த விளையாட்டின் 3D வரைகலையை ஆதரிக்கவில்லை.",
  "Bersedia…": "தயாராகுங்கள்…",
  "Tempat": "இடம்",
  "Medan permainan": "விளையாட்டுப் பகுதி",
  "Sentuh kiri, tengah atau kanan untuk tukar lorong.": "வழியை மாற்ற இடது, நடு அல்லது வலது பக்கம் தொடுங்கள்.",
  "Pandu kart bersama Harraz atau Hannah! Pilih lorong dengan jawapan betul untuk dapat boost. Jawapan salah akan buat kart berpusing.": "Harraz அல்லது Hannah உடன் கார்ட் ஓட்டுங்கள்! சரியான பதில் வழியைத் தேர்ந்தெடுத்தால் வேகம் கூடும். தவறான பதில் கார்ட்டைச் சுழல வைக்கும்.",
  "Jawapan": "பதில்",
  "TAMAT": "முடிவு",
  "Lari Kuiz": "ஓட்ட வினா",
  "Lari 3D bersama Harraz atau Hannah. Lari di bawah jawapan betul dan lompat timbunan buku!": "Harraz அல்லது Hannah உடன் 3D-யில் ஓடுங்கள். சரியான பதிலின் கீழ் ஓடி, புத்தகக் குவியல்களைத் தாண்டுங்கள்!",
  "Lari bersama Harraz atau Hannah! Lari di bawah papan jawapan yang betul. Lompat atau tukar lorong untuk elak timbunan buku.": "Harraz அல்லது Hannah உடன் ஓடுங்கள்! சரியான பதில் பலகையின் கீழ் ஓடுங்கள். புத்தகக் குவியல்களைத் தவிர்க்கத் தாண்டுங்கள் அல்லது வழியை மாற்றுங்கள்.",
  "Sentuh kiri, tengah atau kanan untuk tukar lorong. Leret ke atas untuk lompat.": "வழியை மாற்ற இடது, நடு அல்லது வலது பக்கம் தொடுங்கள். தாண்ட மேலே தேய்க்கவும்.",
  "Lastik Kuiz": "கவண் வினா",
  "Lastik bola ke kotak jawapan yang betul bersama Harraz atau Hannah!": "Harraz அல்லது Hannah உடன், சரியான பதில் உள்ள பெட்டியை நோக்கிப் பந்தைக் கவணால் எறியுங்கள்!",
  "Bantu Harraz atau Hannah melastik! Tarik ke belakang, bidik dan lepaskan untuk pecahkan kotak dengan jawapan betul.": "Harraz அல்லது Hannah கவண் எறிய உதவுங்கள்! பின்னால் இழுத்து, குறிவைத்து, விடுங்கள், சரியான பதில் உள்ள பெட்டியை உடையுங்கள்.",
  "Tarik ke belakang, bidik, kemudian lepaskan.": "பின்னால் இழுத்து, குறிவைத்து, பின்னர் விடுங்கள்.",
  "Cuba lagi!": "மீண்டும் முயலுங்கள்!",
  "Terbang Kuiz": "பறக்கும் வினா",
  "Terbang dengan beg jet melalui gelang jawapan betul bersama Harraz atau Hannah!": "Harraz அல்லது Hannah உடன் ஜெட் பையுடன் சரியான பதில் வளையங்கள் வழியே பறங்கள்!",
  "Terbang dengan beg jet bersama Harraz atau Hannah! Terbang melalui gelang dengan jawapan betul dan kutip bintang.": "Harraz அல்லது Hannah உடன் ஜெட் பையுடன் பறங்கள்! சரியான பதில் உள்ள வளையம் வழியே பறந்து, நட்சத்திரங்களைச் சேகரியுங்கள்.",
  "Sentuh atas, tengah atau bawah untuk naik atau turun.": "மேலே அல்லது கீழே செல்ல மேல், நடு அல்லது கீழ்ப் பகுதியைத் தொடுங்கள்.",
  "Dino Kejar": "டைனோ துரத்தல்",
  "Jadi Dino dan kejar Harraz dan Hannah di padang pasir! Dengar soalan, lari di bawah jawapan yang betul untuk mendekati mereka. Lompat kaktus dan elak burung.": "டைனோவாக மாறி பாலைவனத்தில் Harraz, Hannah-வைத் துரத்துங்கள்! கேள்வியைக் கேட்டு, சரியான பதிலின் கீழ் ஓடி அவர்களை நெருங்குங்கள். கள்ளிச்செடிகளைத் தாண்டி, பறவைகளைத் தவிருங்கள்.",
  "Sentuh kiri, tengah atau kanan untuk tukar lorong. Leret ke atas untuk lompat kaktus.": "பாதையை மாற்ற இடது, நடு அல்லது வலது பக்கத்தைத் தொடுங்கள். கள்ளிச்செடியைத் தாண்ட மேலே தேய்க்கவும்.",
  "Jarak": "தூரம்",
  "Kejar!": "துரத்து!",
  "Dapat!": "பிடிபட்டனர்!",
  "Hampir dapat!": "கிட்டத்தட்ட!",
  "Jadi Dino 3D dan kejar Harraz dan Hannah. Lari di bawah jawapan betul, lompat kaktus!": "3D டைனோவாக Harraz, Hannah-வைத் துரத்துங்கள். சரியான பதிலின் கீழ் ஓடி, கள்ளிச்செடிகளைத் தாண்டுங்கள்!",
  "BM & BI": "மலாய் & ஆங்கிலம்",
  "Jetski Kuiz": "ஜெட்ஸ்கி வினாடி வினா",
  "Tunggang jetski bersama Harraz atau Hannah di sungai bandar! Lalu gelang jawapan yang betul untuk nitro. Elak pelampung dan bot, lompat kayu balak.": "Harraz அல்லது Hannah உடன் நகர ஆற்றில் ஜெட்ஸ்கி ஓட்டுங்கள்! நைட்ரோ பெற சரியான பதில் உள்ள வளையம் வழியே செல்லுங்கள். மிதவைகளையும் படகுகளையும் தவிர்த்து, மரக்கட்டைகளைத் தாண்டுங்கள்.",
  "Tunggang jetski 3D di sungai bandar. Lalu gelang jawapan betul untuk nitro, elak bot!": "நகர ஆற்றில் 3D ஜெட்ஸ்கி ஓட்டுங்கள். நைட்ரோ பெற சரியான பதில் வளையம் வழியே சென்று, படகுகளைத் தவிருங்கள்!",
  "Laju": "வேகம்",
  "km/j": "கி.மீ/ம",
  "Nitro!": "நைட்ரோ!",
};
